// ======================
// ABS
// ======================

const absExercises = [
  {
    id: "ab_cable_crunch_facing_toward",
    name: "Ab Cable Crunch Facing Toward",
    category: "Abs",
    primaryMuscles: ["Rectus Abdominis"],
    secondaryMuscles: [],
    romBias: "Shortened",
    mainTrainingApplication: "Spinal Flexion/Extension",
    movementPattern: "Spinal Flexion",
    equipment: ["Cable"],
    premium: true,
    favorite: true,
  },
  {
    id: "ab_cable_crunch_facing_away",
    name: "Ab Cable Crunch Facing Away",
    category: "Abs",
    primaryMuscles: ["Rectus Abdominis"],
    secondaryMuscles: [],
    romBias: "Lengthened",
    mainTrainingApplication: "Spinal Flexion/Extension",
    movementPattern: "Spinal Flexion",
    equipment: ["Cable"],
    premium: true,
    favorite: false,
  },
  {
    id: "ab_bodyweight_crunch_ball",
    name: "Ab Bodyweight Crunch on Exercise Ball",
    category: "Abs",
    primaryMuscles: ["Rectus Abdominis"],
    secondaryMuscles: [],
    romBias: "Shortened",
    mainTrainingApplication: "Spinal Flexion/Extension",
    movementPattern: "Spinal Flexion",
    equipment: ["Bodyweight", "Exercise Ball"],
    premium: true,
    favorite: false,
  },
  {
    id: "ab_machine_crunch",
    name: "Ab Machine Crunch",
    category: "Abs",
    primaryMuscles: ["Rectus Abdominis"],
    secondaryMuscles: [],
    romBias: "Shortened",
    mainTrainingApplication: "Spinal Flexion/Extension",
    movementPattern: "Spinal Flexion",
    equipment: ["Machine"],
    premium: true,
    favorite: false,
  },
  {
    id: "ab_situps_standard",
    name: "Ab Sit-Ups Standard",
    category: "Abs",
    primaryMuscles: ["Rectus Abdominis"],
    secondaryMuscles: ["Hip Flexors"],
    romBias: "Shortened",
    mainTrainingApplication: "Spinal Flexion/Extension",
    movementPattern: "Spinal Flexion",
    equipment: ["Bodyweight"],
    premium: false,
    favorite: false,
  },
  {
    id: "ab_situps_decline",
    name: "Ab Sit-Ups Decline Bench",
    category: "Abs",
    primaryMuscles: ["Rectus Abdominis"],
    secondaryMuscles: ["Hip Flexors"],
    romBias: "Shortened",
    mainTrainingApplication: "Spinal Flexion/Extension",
    movementPattern: "Spinal Flexion",
    equipment: ["Bodyweight", "Bench"],
    premium: false,
    favorite: false,
  },
  {
    id: "ghd_situps",
    name: "GHD Sit-Ups",
    category: "Abs",
    primaryMuscles: ["Rectus Abdominis"],
    secondaryMuscles: [],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Spinal Flexion/Extension",
    movementPattern: "Spinal Flexion",
    equipment: ["Glute Ham Developer Station (GHD)"],
    premium: true,
    favorite: false,
  },
  {
    id: "ab_reverse_crunch",
    name: "Ab Reverse Crunch",
    category: "Abs",
    primaryMuscles: ["Rectus Abdominis"],
    secondaryMuscles: [],
    romBias: "Lengthened",
    mainTrainingApplication: "Spinal Flexion/Extension",
    movementPattern: "Spinal Flexion",
    equipment: ["Bodyweight"],
    premium: true,
    favorite: false,
  },
  {
    id: "ab_reverse_crunch_ball_pass",
    name: "Ab Reverse Crunch with Exercise Ball Pass",
    category: "Abs",
    primaryMuscles: ["Rectus Abdominis"],
    secondaryMuscles: [],
    romBias: "Lengthened",
    mainTrainingApplication: "Spinal Flexion/Extension",
    movementPattern: "Spinal Flexion",
    equipment: ["Bodyweight", "Exercise Ball"],
    premium: true,
    favorite: false,
  },
  {
    id: "ab_garhammer",
    name: "Ab Garhammer",
    category: "Abs",
    primaryMuscles: ["Rectus Abdominis"],
    secondaryMuscles: ["Hip Flexors"],
    romBias: "Lengthened",
    mainTrainingApplication: "Spinal Flexion/Extension",
    movementPattern: "Spinal Flexion",
    equipment: ["Bodyweight", "Bench"],
    premium: true,
    favorite: false,
  },
  {
    id: "ab_lying_leg_raise",
    name: "Ab Lying Leg Raise",
    category: "Abs",
    primaryMuscles: ["Rectus Abdominis"],
    secondaryMuscles: ["Hip Flexors"],
    romBias: "Lengthened",
    mainTrainingApplication: "Spinal Flexion/Extension",
    movementPattern: "Spinal Flexion",
    equipment: ["Bodyweight"],
    premium: true,
    favorite: false,
  },
  {
    id: "ab_hanging_leg_raise_knees_bent",
    name: "Ab Hanging Leg Raise Knees Bent",
    category: "Abs",
    primaryMuscles: ["Rectus Abdominis"],
    secondaryMuscles: ["Hip Flexors"],
    romBias: "Shortened",
    mainTrainingApplication: "Spinal Flexion/Extension",
    movementPattern: "Spinal Flexion",
    equipment: ["Pull-Up Bar"],
    premium: false,
    favorite: false,
  },
  {
    id: "ab_hanging_leg_raise_knees_straight",
    name: "Ab Hanging Leg Raise Knees Straight",
    category: "Abs",
    primaryMuscles: ["Rectus Abdominis"],
    secondaryMuscles: ["Hip Flexors"],
    romBias: "Shortened",
    mainTrainingApplication: "Spinal Flexion/Extension",
    movementPattern: "Spinal Flexion",
    equipment: ["Pull-Up Bar"],
    premium: true,
    favorite: true,
  },
  {
    id: "captains_chair_leg_raise_bent",
    name: "Ab Captains Chair Leg Raise Knees Bent",
    category: "Abs",
    primaryMuscles: ["Rectus Abdominis"],
    secondaryMuscles: ["Hip Flexors"],
    romBias: "Shortened",
    mainTrainingApplication: "Spinal Flexion/Extension",
    movementPattern: "Spinal Flexion",
    equipment: ["Captains Chair"],
    premium: true,
    favorite: false,
  },
  {
    id: "captains_chair_leg_raise_straight",
    name: "Ab Captains Chair Leg Raise Knees Straight",
    category: "Abs",
    primaryMuscles: ["Rectus Abdominis"],
    secondaryMuscles: ["Hip Flexors"],
    romBias: "Shortened",
    mainTrainingApplication: "Spinal Flexion/Extension",
    movementPattern: "Spinal Flexion",
    equipment: ["Captains Chair"],
    premium: true,
    favorite: false,
  },
  {
    id: "standard_plank",
    name: "Standard Plank on Elbows",
    category: "Abs",
    primaryMuscles: ["Abs"],
    secondaryMuscles: ["Serratus Anterior", "Spinal Erectors"],
    romBias: "-",
    mainTrainingApplication: "Resisted Spinal Extension",
    movementPattern: "Anti-Extension",
    equipment: ["Bodyweight"],
    premium: false,
    favorite: false,
  },
  {
    id: "standard_plank_modified",
    name: "Standard Plank on Elbows Modified",
    category: "Abs",
    primaryMuscles: ["Abs"],
    secondaryMuscles: ["Serratus Anterior", "Spinal Erectors"],
    romBias: "-",
    mainTrainingApplication: "Resisted Spinal Extension",
    movementPattern: "Anti-Extension",
    equipment: ["Bodyweight"],
    premium: true,
    favorite: false,
  },
  {
    id: "plank_renegade_row",
    name: "Standard Plank with Renegade Row",
    category: "Abs",
    primaryMuscles: ["Abs"],
    secondaryMuscles: ["Spinal Erectors", "Rhomboids"],
    romBias: "-",
    mainTrainingApplication: "Resisted Spinal Extension",
    movementPattern: "Anti-Extension",
    equipment: ["Bodyweight", "Dumbbell"],
    premium: true,
    favorite: false,
  },
  {
    id: "plank_pass_through",
    name: "Standard Plank with Pass-Through",
    category: "Abs",
    primaryMuscles: ["Abs"],
    secondaryMuscles: ["Spinal Erectors", "Rhomboids"],
    romBias: "-",
    mainTrainingApplication: "Resisted Spinal Extension",
    movementPattern: "Anti-Extension",
    equipment: ["Bodyweight", "Dumbbell"],
    premium: true,
    favorite: false,
  },
  {
    id: "side_plank_bent_knee",
    name: "Side Plank from Bent Knee",
    category: "Abs",
    primaryMuscles: ["Obliques"],
    secondaryMuscles: ["Glute Medius"],
    romBias: "-",
    mainTrainingApplication: "Resisted Spinal Lateral Flexion",
    movementPattern: "Anti-Lateral Flexion",
    equipment: ["Bodyweight"],
    premium: false,
    favorite: false,
  },
  {
    id: "side_plank_bent_knee_abduction",
    name: "Side Plank from Bent Knee with Hip Abduction",
    category: "Abs",
    primaryMuscles: ["Obliques"],
    secondaryMuscles: ["Glute Medius"],
    romBias: "-",
    mainTrainingApplication: "Resisted Spinal Lateral Flexion",
    movementPattern: "Anti-Lateral Flexion",
    equipment: ["Bodyweight"],
    premium: true,
    favorite: true,
  },
  {
    id: "side_plank_bent_knee_clamshell",
    name: "Side Plank from Bent Knee with Clamshell",
    category: "Abs",
    primaryMuscles: ["Obliques"],
    secondaryMuscles: ["Glute Medius"],
    romBias: "-",
    mainTrainingApplication: "Resisted Spinal Lateral Flexion",
    movementPattern: "Anti-Lateral Flexion",
    equipment: ["Bodyweight"],
    premium: true,
    favorite: false,
  },
  {
    id: "side_plank_straight",
    name: "Side Plank from Straight Knee",
    category: "Abs",
    primaryMuscles: ["Obliques"],
    secondaryMuscles: ["Glute Medius"],
    romBias: "-",
    mainTrainingApplication: "Resisted Spinal Lateral Flexion",
    movementPattern: "Anti-Lateral Flexion",
    equipment: ["Bodyweight"],
    premium: true,
    favorite: false,
  },
  {
    id: "side_plank_straight_abduction",
    name: "Side Plank from Straight Knee with Hip Abduction",
    category: "Abs",
    primaryMuscles: ["Obliques"],
    secondaryMuscles: ["Glute Medius"],
    romBias: "-",
    mainTrainingApplication: "Resisted Spinal Lateral Flexion",
    movementPattern: "Anti-Lateral Flexion",
    equipment: ["Bodyweight"],
    premium: true,
    favorite: false,
  },
];
// ======================
// ERECTORS
// ======================

const erectorExercises = [
  {
    id: "dumbbell_deadlift_standard",
    name: "Dumbbell Deadlift (Standard)",
    category: "Erectors",
    primaryMuscles: ["Spinal Erectors"],
    secondaryMuscles: ["Glutes", "Hamstrings"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Resisted Spinal Flexion",
    movementPattern: "Hip Hinge",
    equipment: ["Dumbbell"],
    premium: false,
    favorite: false,
  },
  {
    id: "barbell_deadlift_standard",
    name: "Barbell Deadlift (Standard)",
    category: "Erectors",
    primaryMuscles: ["Spinal Erectors"],
    secondaryMuscles: ["Glutes", "Hamstrings"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Resisted Spinal Flexion",
    movementPattern: "Hip Hinge",
    equipment: ["Barbell"],
    premium: true,
    favorite: true,
  },
  {
    id: "trap_bar_deadlift",
    name: "Trap Bar Deadlift",
    category: "Erectors",
    primaryMuscles: ["Spinal Erectors"],
    secondaryMuscles: ["Glutes", "Hamstrings"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Resisted Spinal Flexion",
    movementPattern: "Hip Hinge",
    equipment: ["Trap Bar"],
    premium: true,
    favorite: false,
  },
  {
    id: "hyperextension_45_degree_lumbar",
    name: "45 Degree Hyper Extension (Lumbar Focused)",
    category: "Erectors",
    primaryMuscles: ["Spinal Erectors"],
    secondaryMuscles: [],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Spinal Flexion/Extension, Hip Flexion/Extension",
    movementPattern: "Spinal Flexion/Extension",
    equipment: ["Bodyweight", "45 Degree Hyper Extension Station"],
    premium: true,
    favorite: true,
  },
  {
    id: "ghd_90_degree_lumbar",
    name: "90 Degree GHD (Lumbar Focused)",
    category: "Erectors",
    primaryMuscles: ["Spinal Erectors"],
    secondaryMuscles: [],
    romBias: "Shortened",
    mainTrainingApplication: "Spinal Flexion/Extension, Hip Flexion/Extension",
    movementPattern: "Spinal Flexion/Extension",
    equipment: ["Glute Ham Developer Station (GHD)"],
    premium: true,
    favorite: false,
  },
  {
    id: "seated_db_good_morning",
    name: "Seated DB Good Morning",
    category: "Erectors",
    primaryMuscles: ["Spinal Erectors"],
    secondaryMuscles: [],
    romBias: "Lengthened",
    mainTrainingApplication: "Spinal Extension",
    movementPattern: "Spinal Extension",
    equipment: ["Dumbbell", "Bench"],
    premium: false,
    favorite: false,
  },
  {
    id: "seated_barbell_good_morning",
    name: "Seated Barbell Good Morning",
    category: "Erectors",
    primaryMuscles: ["Spinal Erectors"],
    secondaryMuscles: [],
    romBias: "Lengthened",
    mainTrainingApplication: "Spinal Extension",
    movementPattern: "Spinal Extension",
    equipment: ["Barbell", "Bench"],
    premium: true,
    favorite: false,
  },
  {
    id: "standing_barbell_good_morning",
    name: "Standing Barbell Good Morning",
    category: "Erectors",
    primaryMuscles: ["Spinal Erectors"],
    secondaryMuscles: ["Glutes", "Adductor Magnus"],
    romBias: "Lengthened",
    mainTrainingApplication: "Spinal Extension, Hip Extension",
    movementPattern: "Hip Hinge",
    equipment: ["Barbell", "Squat Rack Station"],
    premium: true,
    favorite: false,
  },
  {
    id: "standing_safety_bar_good_morning",
    name: "Standing Safety Bar Good Morning",
    category: "Erectors",
    primaryMuscles: ["Spinal Erectors"],
    secondaryMuscles: ["Glutes", "Adductor Magnus"],
    romBias: "Lengthened",
    mainTrainingApplication: "Spinal Extension, Hip Extension",
    movementPattern: "Hip Hinge",
    equipment: ["Safety Bar", "Squat Rack Station"],
    premium: true,
    favorite: false,
  },
  {
    id: "seated_machine_good_morning",
    name: "Seated Machine Good Morning",
    category: "Erectors",
    primaryMuscles: ["Spinal Erectors"],
    secondaryMuscles: ["Glutes", "Adductor Magnus"],
    romBias: "Lengthened",
    mainTrainingApplication: "Spinal Extension, Hip Extension",
    movementPattern: "Hip Hinge",
    equipment: ["Machine"],
    premium: true,
    favorite: false,
  },
  {
    id: "standing_squat_machine_good_morning",
    name: "Standing Squat Machine Good Morning",
    category: "Erectors",
    primaryMuscles: ["Spinal Erectors"],
    secondaryMuscles: ["Glutes", "Adductor Magnus"],
    romBias: "Lengthened",
    mainTrainingApplication: "Spinal Extension, Hip Extension",
    movementPattern: "Hip Hinge",
    equipment: ["Machine"],
    premium: true,
    favorite: false,
  },
  {
    id: "barbell_rack_pull",
    name: "Barbell Rack Pull",
    category: "Erectors",
    primaryMuscles: ["Spinal Erectors"],
    secondaryMuscles: ["Glutes"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Spinal Extension",
    movementPattern: "Hip Hinge",
    equipment: ["Barbell", "Squat Rack Station"],
    premium: true,
    favorite: false,
  },
  {
    id: "barbell_jefferson_curl",
    name: "Barbell Jefferson Curl",
    category: "Erectors",
    primaryMuscles: ["Spinal Erectors"],
    secondaryMuscles: [],
    romBias: "Lengthened",
    mainTrainingApplication: "Spinal Flexion/Extension",
    movementPattern: "Spinal Flexion/Extension",
    equipment: ["Barbell"],
    premium: true,
    favorite: false,
  },
  {
    id: "cable_pull_through",
    name: "Cable Pull Through",
    category: "Erectors",
    primaryMuscles: ["Spinal Erectors"],
    secondaryMuscles: ["Glutes", "Adductor Magnus"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Spinal Extension, Hip Extension",
    movementPattern: "Hip Hinge",
    equipment: ["Cable"],
    premium: true,
    favorite: false,
  },
];
// ======================
// ROTATION / ANTI-ROTATION
// ======================

const rotationExercises = [
  {
    id: "pallof_band_press",
    name: "Pallof Band Press",
    category: "Rotation",
    primaryMuscles: ["Obliques"],
    secondaryMuscles: ["Abs"],
    romBias: "-",
    mainTrainingApplication: "Resisted Spinal Rotation",
    movementPattern: "Anti-Rotation",
    equipment: ["Band"],
    premium: false,
    favorite: false,
  },
  {
    id: "pallof_cable_press",
    name: "Pallof Cable Press",
    category: "Rotation",
    primaryMuscles: ["Obliques"],
    secondaryMuscles: ["Abs"],
    romBias: "-",
    mainTrainingApplication: "Resisted Spinal Rotation",
    movementPattern: "Anti-Rotation",
    equipment: ["Cable"],
    premium: true,
    favorite: false,
  },
  {
    id: "pallof_band_rotation",
    name: "Pallof Band Rotation",
    category: "Rotation",
    primaryMuscles: ["Obliques"],
    secondaryMuscles: ["Abs"],
    romBias: "Shortened",
    mainTrainingApplication: "Spinal Rotation",
    movementPattern: "Rotation",
    equipment: ["Band"],
    premium: true,
    favorite: false,
  },
  {
    id: "pallof_cable_rotation",
    name: "Pallof Cable Rotation",
    category: "Rotation",
    primaryMuscles: ["Obliques"],
    secondaryMuscles: ["Abs"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Spinal Rotation",
    movementPattern: "Rotation",
    equipment: ["Cable"],
    premium: true,
    favorite: true,
  },
  {
    id: "seated_russian_twist",
    name: "Seated Russian Twists",
    category: "Rotation",
    primaryMuscles: ["Obliques"],
    secondaryMuscles: ["Abs"],
    romBias: "-",
    mainTrainingApplication: "Spinal Rotation",
    movementPattern: "Rotation",
    equipment: ["Bodyweight", "Dumbbell"],
    premium: false,
    favorite: false,
  },
  {
    id: "band_lifts_chops",
    name: "Band Lifts/Chops",
    category: "Rotation",
    primaryMuscles: ["Obliques"],
    secondaryMuscles: ["Abs"],
    romBias: "Shortened",
    mainTrainingApplication: "Spinal Rotation",
    movementPattern: "Rotation",
    equipment: ["Band"],
    premium: true,
    favorite: false,
  },
  {
    id: "cable_lifts_chops",
    name: "Cable Lifts/Chops",
    category: "Rotation",
    primaryMuscles: ["Obliques"],
    secondaryMuscles: ["Abs"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Spinal Rotation",
    movementPattern: "Rotation",
    equipment: ["Cable"],
    premium: true,
    favorite: false,
  },
];
// ======================
// ANTERIOR DELT
// ======================

const anteriorDeltExercises = [
  {
    id: "cable_front_raise_45_toward",
    name: "45 Degree Anterior Delt Cable Front Raise (Facing Toward)",
    category: "Anterior Delt",
    primaryMuscles: ["Anterior Deltoid"],
    secondaryMuscles: [],
    romBias: "Shortened",
    mainTrainingApplication: "Glenohumeral Flexion",
    movementPattern: "Shoulder Flexion",
    equipment: ["Cable"],
    premium: true,
    favorite: false,
  },
  {
    id: "band_front_raise_45",
    name: "45 Degree Anterior Delt Band Front Raise",
    category: "Anterior Delt",
    primaryMuscles: ["Anterior Deltoid"],
    secondaryMuscles: [],
    romBias: "Shortened",
    mainTrainingApplication: "Glenohumeral Flexion",
    movementPattern: "Shoulder Flexion",
    equipment: ["Band"],
    premium: true,
    favorite: false,
  },
  {
    id: "incline_barbell_press_anterior",
    name: "Anterior Delt / Clavicular Pec Incline Barbell Press",
    category: "Anterior Delt",
    primaryMuscles: ["Anterior Deltoid"],
    secondaryMuscles: ["Clavicular Pec", "Triceps"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Glenohumeral Flexion, Elbow Extension",
    movementPattern: "Press",
    equipment: ["Barbell", "Bench"],
    premium: true,
    favorite: false,
  },
  {
    id: "incline_machine_press_anterior",
    name: "Anterior Delt / Clavicular Pec Incline Machine Press",
    category: "Anterior Delt",
    primaryMuscles: ["Anterior Deltoid"],
    secondaryMuscles: ["Clavicular Pec", "Triceps"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Glenohumeral Flexion, Elbow Extension",
    movementPattern: "Press",
    equipment: ["Machine", "Bench"],
    premium: true,
    favorite: true,
  },
  {
    id: "incline_db_press_a1",
    name: "Anterior Delt / Clavicular Pec Incline DB Press - A1",
    category: "Anterior Delt",
    primaryMuscles: ["Anterior Deltoid"],
    secondaryMuscles: ["Clavicular Pec", "Triceps"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Glenohumeral Flexion, Elbow Extension",
    movementPattern: "Press",
    equipment: ["Dumbbell", "Bench"],
    premium: true,
    favorite: false,
  },
  {
    id: "incline_db_press_a2",
    name: "Anterior Delt / Clavicular Pec Incline DB Press - A2",
    category: "Anterior Delt",
    primaryMuscles: ["Anterior Deltoid"],
    secondaryMuscles: ["Clavicular Pec", "Triceps"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Glenohumeral Flexion, Elbow Extension",
    movementPattern: "Press",
    equipment: ["Dumbbell", "Bench"],
    premium: true,
    favorite: false,
  },
  {
    id: "db_front_raise_standard",
    name: "Standing/Seated DB Front Raise",
    category: "Anterior Delt",
    primaryMuscles: ["Anterior Deltoid"],
    secondaryMuscles: ["Core"],
    romBias: "Shortened",
    mainTrainingApplication: "Glenohumeral Flexion",
    movementPattern: "Shoulder Flexion",
    equipment: ["Dumbbell"],
    premium: false,
    favorite: false,
  },
  {
    id: "band_front_raise_standard",
    name: "Standing Anterior Delt Band Front Raise",
    category: "Anterior Delt",
    primaryMuscles: ["Anterior Deltoid"],
    secondaryMuscles: ["Core"],
    romBias: "Shortened",
    mainTrainingApplication: "Glenohumeral Flexion",
    movementPattern: "Shoulder Flexion",
    equipment: ["Band"],
    premium: false,
    favorite: false,
  },
  {
    id: "incline_db_front_raise",
    name: "Seated Incline DB Front Raise",
    category: "Anterior Delt",
    primaryMuscles: ["Anterior Deltoid"],
    secondaryMuscles: [],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Glenohumeral Flexion",
    movementPattern: "Shoulder Flexion",
    equipment: ["Dumbbell", "Bench"],
    premium: true,
    favorite: false,
  },
  {
    id: "incline_cable_front_raise",
    name: "Seated Incline Cable Front Raise",
    category: "Anterior Delt",
    primaryMuscles: ["Anterior Deltoid"],
    secondaryMuscles: [],
    romBias: "Lengthened",
    mainTrainingApplication: "Glenohumeral Flexion",
    movementPattern: "Shoulder Flexion",
    equipment: ["Cable", "Bench"],
    premium: true,
    favorite: false,
  },
  {
    id: "db_shoulder_press",
    name: "Dumbbell Shoulder Press",
    category: "Anterior Delt",
    primaryMuscles: ["Anterior Deltoid"],
    secondaryMuscles: ["Medial Deltoid"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Glenohumeral Flexion/Abduction, Elbow Extension",
    movementPattern: "Press",
    equipment: ["Dumbbell"],
    premium: true,
    favorite: false,
  },
  {
    id: "smith_shoulder_press",
    name: "Smith Machine Shoulder Press",
    category: "Anterior Delt",
    primaryMuscles: ["Anterior Deltoid"],
    secondaryMuscles: ["Medial Deltoid"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Glenohumeral Flexion/Abduction, Elbow Extension",
    movementPattern: "Press",
    equipment: ["Smith Machine"],
    premium: true,
    favorite: true,
  },
  {
    id: "machine_shoulder_press",
    name: "Machine Shoulder Press",
    category: "Anterior Delt",
    primaryMuscles: ["Anterior Deltoid"],
    secondaryMuscles: ["Medial Deltoid"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Glenohumeral Flexion/Abduction, Elbow Extension",
    movementPattern: "Press",
    equipment: ["Machine"],
    premium: true,
    favorite: false,
  },
  {
    id: "barbell_shoulder_press",
    name: "Barbell Shoulder Press",
    category: "Anterior Delt",
    primaryMuscles: ["Anterior Deltoid"],
    secondaryMuscles: ["Medial Deltoid"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Glenohumeral Flexion/Abduction, Elbow Extension",
    movementPattern: "Press",
    equipment: ["Barbell"],
    premium: true,
    favorite: false,
  },
  {
    id: "band_shoulder_press",
    name: "Band Shoulder Press",
    category: "Anterior Delt",
    primaryMuscles: ["Anterior Deltoid"],
    secondaryMuscles: ["Medial Deltoid"],
    romBias: "Shortened",
    mainTrainingApplication: "Glenohumeral Flexion/Abduction, Elbow Extension",
    movementPattern: "Press",
    equipment: ["Band"],
    premium: true,
    favorite: false,
  },
];
// ======================
// MEDIAL DELT
// ======================

const medialDeltExercises = [
  {
    id: "cable_y_raise_facing_toward",
    name: "Cable Medial Delt Y-Raise (Facing Toward)",
    category: "Medial Delt",
    primaryMuscles: ["Medial Deltoid"],
    secondaryMuscles: ["Lower Trap", "Posterior Deltoid"],
    romBias: "Shortened",
    mainTrainingApplication: "Glenohumeral Abduction/Flexion",
    movementPattern: "Shoulder Abduction/Flexion",
    equipment: ["Cable"],
    premium: true,
    favorite: true,
  },
  {
    id: "band_y_raise",
    name: "Band Medial Delt Y-Raise",
    category: "Medial Delt",
    primaryMuscles: ["Medial Deltoid"],
    secondaryMuscles: ["Lower Trap", "Posterior Deltoid"],
    romBias: "Shortened",
    mainTrainingApplication: "Glenohumeral Abduction/Flexion",
    movementPattern: "Shoulder Abduction/Flexion",
    equipment: ["Band"],
    premium: false,
    favorite: false,
  },
  {
    id: "incline_db_y_raise",
    name: "Incline Bench Medial Delt Y-Raise",
    category: "Medial Delt",
    primaryMuscles: ["Medial Deltoid"],
    secondaryMuscles: ["Lower Trap", "Posterior Deltoid"],
    romBias: "Shortened",
    mainTrainingApplication: "Glenohumeral Abduction/Flexion",
    movementPattern: "Shoulder Abduction/Flexion",
    equipment: ["Dumbbell", "Bench"],
    premium: true,
    favorite: false,
  },
  {
    id: "cable_y_raise_facing_away",
    name: "Cable Medial Delt Y-Raise (Facing Away)",
    category: "Medial Delt",
    primaryMuscles: ["Medial Deltoid"],
    secondaryMuscles: ["Lower Trap", "Posterior Deltoid"],
    romBias: "Lengthened",
    mainTrainingApplication: "Glenohumeral Abduction/Flexion",
    movementPattern: "Shoulder Abduction/Flexion",
    equipment: ["Cable"],
    premium: true,
    favorite: true,
  },
  {
    id: "low_cable_lateral_raise",
    name: "Low Cable Medial Delt Lateral Raise",
    category: "Medial Delt",
    primaryMuscles: ["Medial Deltoid"],
    secondaryMuscles: [],
    romBias: "Shortened",
    mainTrainingApplication: "Glenohumeral Abduction",
    movementPattern: "Shoulder Abduction",
    equipment: ["Cable"],
    premium: true,
    favorite: false,
  },
  {
    id: "db_lateral_raise",
    name: "Standing/Seated DB Medial Delt Lateral Raise",
    category: "Medial Delt",
    primaryMuscles: ["Medial Deltoid"],
    secondaryMuscles: ["Core"],
    romBias: "Shortened",
    mainTrainingApplication: "Glenohumeral Abduction",
    movementPattern: "Shoulder Abduction",
    equipment: ["Dumbbell"],
    premium: false,
    favorite: false,
  },
  {
    id: "band_lateral_raise",
    name: "Standing Band Medial Delt Lateral Raise",
    category: "Medial Delt",
    primaryMuscles: ["Medial Deltoid"],
    secondaryMuscles: ["Core"],
    romBias: "Shortened",
    mainTrainingApplication: "Glenohumeral Abduction",
    movementPattern: "Shoulder Abduction",
    equipment: ["Band"],
    premium: false,
    favorite: false,
  },
  {
    id: "mid_cable_lateral_raise",
    name: "Mid-Height Cable Medial Delt Lateral Raise",
    category: "Medial Delt",
    primaryMuscles: ["Medial Deltoid"],
    secondaryMuscles: [],
    romBias: "Lengthened",
    mainTrainingApplication: "Glenohumeral Abduction",
    movementPattern: "Shoulder Abduction",
    equipment: ["Cable"],
    premium: true,
    favorite: true,
  },
  {
    id: "incline_lateral_raise",
    name: "Incline Bench Medial Delt Lateral Raise",
    category: "Medial Delt",
    primaryMuscles: ["Medial Deltoid"],
    secondaryMuscles: ["Lower Trap", "Posterior Deltoid"],
    romBias: "Lengthened",
    mainTrainingApplication: "Glenohumeral Abduction",
    movementPattern: "Shoulder Abduction",
    equipment: ["Dumbbell", "Bench"],
    premium: true,
    favorite: false,
  },
  {
    id: "prone_lateral_raise",
    name: "Prone DB Bench Medial Delt Lateral Raise",
    category: "Medial Delt",
    primaryMuscles: ["Medial Deltoid"],
    secondaryMuscles: ["Lower Trap", "Posterior Deltoid"],
    romBias: "Shortened",
    mainTrainingApplication: "Glenohumeral Horizontal Abduction",
    movementPattern: "Horizontal Abduction",
    equipment: ["Dumbbell", "Bench"],
    premium: false,
    favorite: false,
  },
  {
    id: "prone_y_raise",
    name: "Prone DB Bench Medial Delt Y-Raise",
    category: "Medial Delt",
    primaryMuscles: ["Medial Deltoid"],
    secondaryMuscles: ["Lower Trap", "Posterior Deltoid"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Glenohumeral Abduction/Flexion",
    movementPattern: "Shoulder Abduction/Flexion",
    equipment: ["Dumbbell", "Bench"],
    premium: true,
    favorite: false,
  },
  {
    id: "upright_row_db",
    name: "Upright Row with Dumbbell",
    category: "Medial Delt",
    primaryMuscles: ["Medial Deltoid"],
    secondaryMuscles: ["Upper Trap", "Anterior/Posterior Deltoid"],
    romBias: "Shortened",
    mainTrainingApplication: "Glenohumeral Abduction",
    movementPattern: "Shoulder Abduction",
    equipment: ["Dumbbell"],
    premium: false,
    favorite: false,
  },
  {
    id: "upright_row_band",
    name: "Upright Row with Band",
    category: "Medial Delt",
    primaryMuscles: ["Medial Deltoid"],
    secondaryMuscles: ["Upper Trap", "Anterior/Posterior Deltoid"],
    romBias: "Shortened",
    mainTrainingApplication: "Glenohumeral Abduction",
    movementPattern: "Shoulder Abduction",
    equipment: ["Band"],
    premium: true,
    favorite: false,
  },
  {
    id: "upright_row_cable",
    name: "Upright Row with Cable",
    category: "Medial Delt",
    primaryMuscles: ["Medial Deltoid"],
    secondaryMuscles: ["Upper Trap", "Anterior/Posterior Deltoid"],
    romBias: "Shortened",
    mainTrainingApplication: "Glenohumeral Abduction",
    movementPattern: "Shoulder Abduction",
    equipment: ["Cable"],
    premium: true,
    favorite: false,
  },
];
// ======================
// POSTERIOR DELT
// ======================

const posteriorDeltExercises = [
  {
    id: "db_reverse_fly",
    name: "Posterior Delt DB Reverse Fly",
    category: "Posterior Delt",
    primaryMuscles: ["Posterior Deltoid"],
    secondaryMuscles: ["Mid Trap", "Rhomboids"],
    romBias: "Shortened",
    mainTrainingApplication: "Glenohumeral Horizontal Abduction",
    movementPattern: "Horizontal Abduction",
    equipment: ["Dumbbell", "Bench"],
    premium: false,
    favorite: false,
  },
  {
    id: "machine_reverse_fly",
    name: "Posterior Delt Machine Reverse Fly",
    category: "Posterior Delt",
    primaryMuscles: ["Posterior Deltoid"],
    secondaryMuscles: ["Mid Trap", "Rhomboids"],
    romBias: "Shortened",
    mainTrainingApplication: "Glenohumeral Horizontal Abduction",
    movementPattern: "Horizontal Abduction",
    equipment: ["Machine"],
    premium: true,
    favorite: false,
  },
  {
    id: "band_reverse_fly",
    name: "Posterior Delt Band Reverse Fly",
    category: "Posterior Delt",
    primaryMuscles: ["Posterior Deltoid"],
    secondaryMuscles: ["Mid Trap", "Rhomboids"],
    romBias: "Shortened",
    mainTrainingApplication: "Glenohumeral Horizontal Abduction",
    movementPattern: "Horizontal Abduction",
    equipment: ["Band"],
    premium: false,
    favorite: false,
  },
  {
    id: "cable_reverse_fly",
    name: "Posterior Delt Cable Reverse Fly",
    category: "Posterior Delt",
    primaryMuscles: ["Posterior Deltoid"],
    secondaryMuscles: ["Mid Trap", "Rhomboids"],
    romBias: "Shortened",
    mainTrainingApplication: "Glenohumeral Horizontal Abduction",
    movementPattern: "Horizontal Abduction",
    equipment: ["Cable"],
    premium: true,
    favorite: false,
  },
  {
    id: "posterior_delt_db_row",
    name: "Posterior Delt DB Row",
    category: "Posterior Delt",
    primaryMuscles: ["Posterior Deltoid"],
    secondaryMuscles: ["Mid Trap", "Rhomboids"],
    romBias: "Shortened",
    mainTrainingApplication: "Glenohumeral Horizontal Abduction",
    movementPattern: "Row",
    equipment: ["Dumbbell", "Bench"],
    premium: true,
    favorite: false,
  },
  {
    id: "posterior_delt_machine_row",
    name: "Posterior Delt Machine Row",
    category: "Posterior Delt",
    primaryMuscles: ["Posterior Deltoid"],
    secondaryMuscles: ["Mid Trap", "Rhomboids"],
    romBias: "Shortened",
    mainTrainingApplication: "Glenohumeral Horizontal Abduction",
    movementPattern: "Row",
    equipment: ["Machine"],
    premium: true,
    favorite: false,
  },
  {
    id: "posterior_delt_cable_row",
    name: "Posterior Delt Cable Row",
    category: "Posterior Delt",
    primaryMuscles: ["Posterior Deltoid"],
    secondaryMuscles: ["Mid Trap", "Rhomboids"],
    romBias: "Shortened",
    mainTrainingApplication: "Glenohumeral Horizontal Abduction",
    movementPattern: "Row",
    equipment: ["Cable"],
    premium: true,
    favorite: false,
  },
  {
    id: "cable_pull_around_toward",
    name: "Cable Posterior Delt Pull-Around (Facing Toward)",
    category: "Posterior Delt",
    primaryMuscles: ["Posterior Deltoid"],
    secondaryMuscles: [],
    romBias: "Shortened",
    mainTrainingApplication: "Glenohumeral Horizontal Abduction",
    movementPattern: "Horizontal Abduction",
    equipment: ["Cable"],
    premium: true,
    favorite: true,
  },
  {
    id: "cable_pull_around_away",
    name: "Cable Posterior Delt Pull-Around (Facing Away)",
    category: "Posterior Delt",
    primaryMuscles: ["Posterior Deltoid"],
    secondaryMuscles: [],
    romBias: "Lengthened",
    mainTrainingApplication: "Glenohumeral Horizontal Abduction",
    movementPattern: "Horizontal Abduction",
    equipment: ["Cable"],
    premium: true,
    favorite: true,
  },
  {
    id: "posterior_delt_incline_row",
    name: "Posterior Delt Incline Row",
    category: "Posterior Delt",
    primaryMuscles: ["Posterior Deltoid"],
    secondaryMuscles: ["Mid Trap", "Rhomboids"],
    romBias: "Shortened",
    mainTrainingApplication: "Glenohumeral Horizontal Abduction",
    movementPattern: "Row",
    equipment: ["Dumbbell", "Bench"],
    premium: true,
    favorite: false,
  },
  {
    id: "posterior_delt_cable_pulldown",
    name: "Posterior Delt Cable Pulldown",
    category: "Posterior Delt",
    primaryMuscles: ["Posterior Deltoid"],
    secondaryMuscles: ["Lats", "Teres Major"],
    romBias: "Shortened",
    mainTrainingApplication: "Shoulder Extension",
    movementPattern: "Pulldown",
    equipment: ["Cable"],
    premium: true,
    favorite: false,
  },
  {
    id: "posterior_delt_machine_pulldown",
    name: "Posterior Delt Machine Pulldown",
    category: "Posterior Delt",
    primaryMuscles: ["Posterior Deltoid"],
    secondaryMuscles: ["Lats", "Teres Major"],
    romBias: "Shortened",
    mainTrainingApplication: "Shoulder Extension",
    movementPattern: "Pulldown",
    equipment: ["Machine"],
    premium: true,
    favorite: false,
  },
  {
    id: "face_pull_band",
    name: "Face Pulls with Band",
    category: "Posterior Delt",
    primaryMuscles: ["Posterior Deltoid"],
    secondaryMuscles: ["Mid Trap", "Rhomboids"],
    romBias: "Shortened",
    mainTrainingApplication:
      "Glenohumeral Horizontal Abduction, External Rotation",
    movementPattern: "Horizontal Abduction",
    equipment: ["Band"],
    premium: false,
    favorite: false,
  },
  {
    id: "face_pull_cable",
    name: "Face Pulls with Cable",
    category: "Posterior Delt",
    primaryMuscles: ["Posterior Deltoid"],
    secondaryMuscles: ["Mid Trap", "Rhomboids"],
    romBias: "Shortened",
    mainTrainingApplication:
      "Glenohumeral Horizontal Abduction, External Rotation",
    movementPattern: "Horizontal Abduction",
    equipment: ["Cable"],
    premium: true,
    favorite: false,
  },
  {
    id: "incline_posterior_delt_swings",
    name: "Incline Bench Posterior Delt Raises/Swings",
    category: "Posterior Delt",
    primaryMuscles: ["Posterior Deltoid"],
    secondaryMuscles: ["Mid Trap", "Rhomboids"],
    romBias: "Shortened",
    mainTrainingApplication: "Glenohumeral Horizontal Abduction",
    movementPattern: "Horizontal Abduction",
    equipment: ["Dumbbell", "Bench"],
    premium: true,
    favorite: true,
  },
];
// ======================
// BICEPS
// ======================

const bicepsExercises = [
  {
    id: "db_bicep_curl_supinated",
    name: "Standing/Seated Supinated DB Bicep Curl",
    category: "Biceps",
    primaryMuscles: ["Biceps"],
    secondaryMuscles: ["Supinator", "Brachialis"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Elbow Flexion",
    movementPattern: "Elbow Flexion",
    equipment: ["Dumbbell"],
    premium: false,
    favorite: false,
  },
  {
    id: "cable_bicep_curl_unilateral",
    name: "Supinated Unilateral Cable Bicep Curl",
    category: "Biceps",
    primaryMuscles: ["Biceps"],
    secondaryMuscles: ["Supinator", "Brachialis"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Elbow Flexion",
    movementPattern: "Elbow Flexion",
    equipment: ["Cable"],
    premium: true,
    favorite: false,
  },
  {
    id: "cable_cross_body_curl",
    name: "Cross-Body Unilateral Cable Bicep Curl",
    category: "Biceps",
    primaryMuscles: ["Biceps (Short Head)"],
    secondaryMuscles: ["Brachialis"],
    romBias: "Shortened",
    mainTrainingApplication: "Elbow Flexion, Glenohumeral Adduction/Flexion",
    movementPattern: "Elbow Flexion",
    equipment: ["Cable"],
    premium: true,
    favorite: true,
  },
  {
    id: "cable_bicep_curl_bilateral",
    name: "Supinated Bilateral Cable Bicep Curl",
    category: "Biceps",
    primaryMuscles: ["Biceps"],
    secondaryMuscles: ["Supinator", "Brachialis"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Elbow Flexion",
    movementPattern: "Elbow Flexion",
    equipment: ["Cable"],
    premium: true,
    favorite: false,
  },
  {
    id: "bb_bicep_curl",
    name: "Supinated BB Bicep Curl",
    category: "Biceps",
    primaryMuscles: ["Biceps"],
    secondaryMuscles: ["Supinator", "Brachialis"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Elbow Flexion, Glenohumeral Flexion",
    movementPattern: "Elbow Flexion",
    equipment: ["Barbell"],
    premium: true,
    favorite: false,
  },
  {
    id: "band_bicep_curl",
    name: "Supinated Band Bicep Curl",
    category: "Biceps",
    primaryMuscles: ["Biceps"],
    secondaryMuscles: ["Supinator", "Brachialis"],
    romBias: "Shortened",
    mainTrainingApplication: "Elbow Flexion",
    movementPattern: "Elbow Flexion",
    equipment: ["Band"],
    premium: true,
    favorite: false,
  },
  {
    id: "high_cable_curl",
    name: "High Cable Bicep Curl",
    category: "Biceps",
    primaryMuscles: ["Biceps (Long Head)"],
    secondaryMuscles: ["Brachialis"],
    romBias: "Shortened",
    mainTrainingApplication: "Elbow Flexion, Glenohumeral Flexion",
    movementPattern: "Elbow Flexion",
    equipment: ["Cable"],
    premium: true,
    favorite: true,
  },
  {
    id: "db_concentration_curl",
    name: "Seated DB Concentration Curl",
    category: "Biceps",
    primaryMuscles: ["Biceps (Short Head)"],
    secondaryMuscles: ["Brachialis"],
    romBias: "Shortened",
    mainTrainingApplication: "Elbow Flexion, Glenohumeral Adduction/Flexion",
    movementPattern: "Elbow Flexion",
    equipment: ["Dumbbell"],
    premium: true,
    favorite: false,
  },
  {
    id: "db_preacher_curl",
    name: "DB Preacher Curl",
    category: "Biceps",
    primaryMuscles: ["Biceps (Short Head)"],
    secondaryMuscles: ["Brachialis"],
    romBias: "Lengthened",
    mainTrainingApplication: "Elbow Flexion, Glenohumeral Flexion",
    movementPattern: "Elbow Flexion",
    equipment: ["Dumbbell", "Preacher Bench"],
    premium: true,
    favorite: false,
  },
  {
    id: "cable_preacher_curl",
    name: "Cable Preacher Curl",
    category: "Biceps",
    primaryMuscles: ["Biceps (Short Head)"],
    secondaryMuscles: ["Brachialis"],
    romBias: "Lengthened",
    mainTrainingApplication: "Elbow Flexion, Glenohumeral Flexion",
    movementPattern: "Elbow Flexion",
    equipment: ["Cable", "Preacher Bench"],
    premium: true,
    favorite: true,
  },
  {
    id: "machine_preacher_curl",
    name: "Machine Preacher Curl",
    category: "Biceps",
    primaryMuscles: ["Biceps (Short Head)"],
    secondaryMuscles: ["Brachialis"],
    romBias: "Lengthened",
    mainTrainingApplication: "Elbow Flexion, Glenohumeral Flexion",
    movementPattern: "Elbow Flexion",
    equipment: ["Machine"],
    premium: true,
    favorite: true,
  },
  {
    id: "bb_preacher_curl",
    name: "BB Preacher Curl",
    category: "Biceps",
    primaryMuscles: ["Biceps (Short Head)"],
    secondaryMuscles: ["Brachialis"],
    romBias: "Lengthened",
    mainTrainingApplication: "Elbow Flexion, Glenohumeral Flexion",
    movementPattern: "Elbow Flexion",
    equipment: ["Barbell", "Preacher Bench"],
    premium: true,
    favorite: false,
  },
  {
    id: "incline_db_curl",
    name: "Incline DB Curl",
    category: "Biceps",
    primaryMuscles: ["Biceps (Long Head)"],
    secondaryMuscles: ["Brachialis"],
    romBias: "Lengthened",
    mainTrainingApplication: "Elbow Flexion, Glenohumeral Extension",
    movementPattern: "Elbow Flexion",
    equipment: ["Dumbbell", "Bench"],
    premium: true,
    favorite: false,
  },
  {
    id: "cable_curl_facing_away",
    name: "Standing Cable Curl (Facing Away)",
    category: "Biceps",
    primaryMuscles: ["Biceps (Long Head)"],
    secondaryMuscles: ["Brachialis"],
    romBias: "Lengthened",
    mainTrainingApplication: "Elbow Flexion, Glenohumeral Extension",
    movementPattern: "Elbow Flexion",
    equipment: ["Cable"],
    premium: true,
    favorite: false,
  },
  {
    id: "spider_curl",
    name: "Prone Incline Bench Spider Curl",
    category: "Biceps",
    primaryMuscles: ["Biceps (Short Head)"],
    secondaryMuscles: ["Brachialis"],
    romBias: "Shortened",
    mainTrainingApplication: "Elbow Flexion, Glenohumeral Flexion",
    movementPattern: "Elbow Flexion",
    equipment: ["Dumbbell", "Bench"],
    premium: true,
    favorite: false,
  },
  {
    id: "wide_high_cable_curl",
    name: "Wide-High Cable Curl (Facing Away)",
    category: "Biceps",
    primaryMuscles: ["Biceps (Long Head)"],
    secondaryMuscles: ["Brachialis"],
    romBias: "Lengthened",
    mainTrainingApplication: "Elbow Flexion, Glenohumeral Extension/Abduction",
    movementPattern: "Elbow Flexion",
    equipment: ["Cable"],
    premium: true,
    favorite: false,
  },
  {
    id: "neutral_db_curl",
    name: "Neutral Wrist DB Brachialis Curl",
    category: "Biceps",
    primaryMuscles: ["Brachialis"],
    secondaryMuscles: ["Biceps", "Brachioradialis"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Elbow Flexion",
    movementPattern: "Elbow Flexion",
    equipment: ["Dumbbell"],
    premium: false,
    favorite: false,
  },
  {
    id: "neutral_band_curl",
    name: "Neutral Wrist Band Brachialis Curl",
    category: "Biceps",
    primaryMuscles: ["Brachialis"],
    secondaryMuscles: ["Biceps", "Brachioradialis"],
    romBias: "Shortened",
    mainTrainingApplication: "Elbow Flexion",
    movementPattern: "Elbow Flexion",
    equipment: ["Band"],
    premium: true,
    favorite: false,
  },
  {
    id: "neutral_cable_unilateral_curl",
    name: "Neutral Wrist Cable Unilateral Brachialis Curl",
    category: "Biceps",
    primaryMuscles: ["Brachialis"],
    secondaryMuscles: ["Biceps", "Brachioradialis"],
    romBias: "Shortened",
    mainTrainingApplication: "Elbow Flexion",
    movementPattern: "Elbow Flexion",
    equipment: ["Cable"],
    premium: true,
    favorite: false,
  },
  {
    id: "rope_brachialis_curl",
    name: "Neutral Wrist Cable Rope Brachialis Curl",
    category: "Biceps",
    primaryMuscles: ["Brachialis"],
    secondaryMuscles: ["Biceps", "Brachioradialis"],
    romBias: "Shortened",
    mainTrainingApplication: "Elbow Flexion, Glenohumeral Flexion",
    movementPattern: "Elbow Flexion",
    equipment: ["Cable"],
    premium: true,
    favorite: false,
  },
  {
    id: "pronated_curl",
    name: "Pronating Brachioradialis Curl",
    category: "Biceps",
    primaryMuscles: ["Brachioradialis"],
    secondaryMuscles: ["Brachialis"],
    romBias: "Shortened",
    mainTrainingApplication: "Elbow Flexion, Glenohumeral Flexion",
    movementPattern: "Elbow Flexion",
    equipment: ["Dumbbell"],
    premium: true,
    favorite: true,
  },
  {
    id: "incline_brachialis_curl",
    name: "Incline Bench Brachialis Curl",
    category: "Biceps",
    primaryMuscles: ["Brachialis"],
    secondaryMuscles: ["Biceps", "Brachioradialis"],
    romBias: "Lengthened",
    mainTrainingApplication: "Elbow Flexion, Glenohumeral Extension",
    movementPattern: "Elbow Flexion",
    equipment: ["Dumbbell", "Bench"],
    premium: true,
    favorite: false,
  },
  {
    id: "spider_brachialis_curl",
    name: "Prone Incline Bench Spider Brachialis Curl",
    category: "Biceps",
    primaryMuscles: ["Brachialis"],
    secondaryMuscles: ["Biceps", "Brachioradialis"],
    romBias: "Shortened",
    mainTrainingApplication: "Elbow Flexion, Glenohumeral Flexion",
    movementPattern: "Elbow Flexion",
    equipment: ["Dumbbell", "Bench"],
    premium: true,
    favorite: false,
  },
];
// ======================
// TRICEPS
// ======================

const tricepsExercises = [
  {
    id: "db_tricep_kickback",
    name: "Bent Over DB Tricep Kickback",
    category: "Triceps",
    primaryMuscles: ["Triceps (Long Head)"],
    secondaryMuscles: ["Triceps (Medial/Lateral Head)"],
    romBias: "Shortened",
    mainTrainingApplication: "Elbow Extension, Glenohumeral Extension",
    movementPattern: "Elbow Extension",
    equipment: ["Dumbbell", "Bench"],
    premium: false,
    favorite: false,
  },
  {
    id: "cable_tricep_extension_unilateral",
    name: "Unilateral Cable Tricep Extension",
    category: "Triceps",
    primaryMuscles: ["Triceps (Medial/Lateral Head)"],
    secondaryMuscles: ["Triceps (Long Head)"],
    romBias: "Shortened",
    mainTrainingApplication: "Elbow Extension, Glenohumeral Extension",
    movementPattern: "Elbow Extension",
    equipment: ["Cable"],
    premium: true,
    favorite: true,
  },
  {
    id: "cable_tricep_pushdown",
    name: "Rope/Straight Bar Cable Tricep Extension",
    category: "Triceps",
    primaryMuscles: ["Triceps (Medial/Lateral Head)"],
    secondaryMuscles: ["Triceps (Long Head)"],
    romBias: "Shortened",
    mainTrainingApplication: "Elbow Extension, Glenohumeral Extension",
    movementPattern: "Elbow Extension",
    equipment: ["Cable"],
    premium: true,
    favorite: false,
  },
  {
    id: "band_tricep_extension",
    name: "Band Tricep Extension",
    category: "Triceps",
    primaryMuscles: ["Triceps (Medial/Lateral Head)"],
    secondaryMuscles: ["Triceps (Long Head)"],
    romBias: "Shortened",
    mainTrainingApplication: "Elbow Extension, Glenohumeral Extension",
    movementPattern: "Elbow Extension",
    equipment: ["Band"],
    premium: false,
    favorite: false,
  },
  {
    id: "db_overhead_tricep_extension",
    name: "Overhead Unilateral DB Tricep Extension",
    category: "Triceps",
    primaryMuscles: ["Triceps (Long Head)"],
    secondaryMuscles: ["Triceps (Medial/Lateral Head)"],
    romBias: "Lengthened",
    mainTrainingApplication: "Elbow Extension, Glenohumeral Flexion",
    movementPattern: "Elbow Extension",
    equipment: ["Dumbbell"],
    premium: true,
    favorite: false,
  },
  {
    id: "cable_overhead_tricep_extension",
    name: "Overhead Unilateral Cable Tricep Extension",
    category: "Triceps",
    primaryMuscles: ["Triceps (Long Head)"],
    secondaryMuscles: ["Triceps (Medial/Lateral Head)"],
    romBias: "Lengthened",
    mainTrainingApplication: "Elbow Extension, Glenohumeral Flexion",
    movementPattern: "Elbow Extension",
    equipment: ["Cable"],
    premium: true,
    favorite: false,
  },
  {
    id: "band_overhead_tricep_extension",
    name: "Overhead Band Tricep Extension",
    category: "Triceps",
    primaryMuscles: ["Triceps (Long Head)"],
    secondaryMuscles: ["Triceps (Medial/Lateral Head)"],
    romBias: "Shortened",
    mainTrainingApplication: "Elbow Extension, Glenohumeral Flexion",
    movementPattern: "Elbow Extension",
    equipment: ["Band"],
    premium: false,
    favorite: false,
  },
  {
    id: "cable_overhead_rope_extension",
    name: "Overhead Rope/Straight Bar Cable Tricep Extension",
    category: "Triceps",
    primaryMuscles: ["Triceps (Long Head)"],
    secondaryMuscles: ["Triceps (Medial/Lateral Head)"],
    romBias: "Lengthened",
    mainTrainingApplication: "Elbow Extension, Glenohumeral Flexion",
    movementPattern: "Elbow Extension",
    equipment: ["Cable"],
    premium: true,
    favorite: false,
  },
  {
    id: "katana_tricep_extension",
    name: "Katana Cable Overhead Tricep Extension",
    category: "Triceps",
    primaryMuscles: ["Triceps (Long Head)"],
    secondaryMuscles: ["Triceps (Medial/Lateral Head)"],
    romBias: "Lengthened",
    mainTrainingApplication: "Elbow Extension, Glenohumeral Flexion",
    movementPattern: "Elbow Extension",
    equipment: ["Cable"],
    premium: true,
    favorite: false,
  },
  {
    id: "flat_db_tricep_extension",
    name: "Flat Bench DB Tricep Extension",
    category: "Triceps",
    primaryMuscles: ["Triceps (Long Head)"],
    secondaryMuscles: ["Triceps (Medial/Lateral Head)"],
    romBias: "Lengthened",
    mainTrainingApplication: "Elbow Extension, Glenohumeral Flexion",
    movementPattern: "Elbow Extension",
    equipment: ["Dumbbell", "Bench"],
    premium: true,
    favorite: false,
  },
  {
    id: "flat_cable_tricep_extension",
    name: "Flat Bench Cable Tricep Extension",
    category: "Triceps",
    primaryMuscles: ["Triceps (Long Head)"],
    secondaryMuscles: ["Triceps (Medial/Lateral Head)"],
    romBias: "Lengthened",
    mainTrainingApplication: "Elbow Extension, Glenohumeral Flexion",
    movementPattern: "Elbow Extension",
    equipment: ["Cable", "Bench"],
    premium: true,
    favorite: false,
  },
  {
    id: "incline_db_tricep_extension",
    name: "Incline Bench DB Tricep Extension",
    category: "Triceps",
    primaryMuscles: ["Triceps (Long Head)"],
    secondaryMuscles: ["Triceps (Medial/Lateral Head)"],
    romBias: "Lengthened",
    mainTrainingApplication: "Elbow Extension, Glenohumeral Flexion",
    movementPattern: "Elbow Extension",
    equipment: ["Dumbbell", "Bench"],
    premium: true,
    favorite: false,
  },
  {
    id: "incline_cable_tricep_extension",
    name: "Incline Bench Cable Tricep Extension",
    category: "Triceps",
    primaryMuscles: ["Triceps (Long Head)"],
    secondaryMuscles: ["Triceps (Medial/Lateral Head)"],
    romBias: "Lengthened",
    mainTrainingApplication: "Elbow Extension, Glenohumeral Flexion",
    movementPattern: "Elbow Extension",
    equipment: ["Cable", "Bench"],
    premium: true,
    favorite: false,
  },
  {
    id: "over_same_shoulder_press",
    name: "Over-Same Shoulder Cable Tricep Press",
    category: "Triceps",
    primaryMuscles: ["Triceps (Lateral Head)"],
    secondaryMuscles: ["Triceps (Medial/Long Head)"],
    romBias: "Lengthened",
    mainTrainingApplication: "Elbow Extension, Glenohumeral Adduction",
    movementPattern: "Elbow Extension",
    equipment: ["Cable"],
    premium: true,
    favorite: true,
  },
  {
    id: "cross_body_press_away",
    name: "Cross-Body Cable Tricep Press (Facing Away)",
    category: "Triceps",
    primaryMuscles: ["Triceps (Lateral Head)"],
    secondaryMuscles: ["Triceps (Medial/Long Head)"],
    romBias: "Lengthened",
    mainTrainingApplication: "Elbow Extension, Glenohumeral Extension",
    movementPattern: "Elbow Extension",
    equipment: ["Cable"],
    premium: true,
    favorite: true,
  },
  {
    id: "cross_body_press_toward",
    name: "Cross-Body Cable Tricep Press (Facing Toward)",
    category: "Triceps",
    primaryMuscles: ["Triceps (Lateral Head)"],
    secondaryMuscles: ["Triceps (Medial/Long Head)"],
    romBias: "Shortened",
    mainTrainingApplication: "Elbow Extension, Glenohumeral Flexion",
    movementPattern: "Elbow Extension",
    equipment: ["Cable"],
    premium: true,
    favorite: true,
  },
  {
    id: "jm_machine_press",
    name: "JM Tricep Machine Press",
    category: "Triceps",
    primaryMuscles: ["Triceps (Lateral/Medial Head)"],
    secondaryMuscles: ["Triceps (Long Head)"],
    romBias: "Lengthened",
    mainTrainingApplication: "Elbow Extension, Glenohumeral Flexion",
    movementPattern: "Press",
    equipment: ["Machine"],
    premium: true,
    favorite: false,
  },
  {
    id: "jm_db_press",
    name: "JM DB Tricep Press",
    category: "Triceps",
    primaryMuscles: ["Triceps (Lateral/Medial Head)"],
    secondaryMuscles: ["Triceps (Long Head)"],
    romBias: "Lengthened",
    mainTrainingApplication: "Elbow Extension, Glenohumeral Flexion",
    movementPattern: "Press",
    equipment: ["Dumbbell", "Bench"],
    premium: true,
    favorite: false,
  },
  {
    id: "bench_dips",
    name: "Bench Dips (Upright Torso)",
    category: "Triceps",
    primaryMuscles: ["Triceps"],
    secondaryMuscles: [],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Elbow Extension, Glenohumeral Extension",
    movementPattern: "Elbow Extension",
    equipment: ["Bodyweight", "Bench"],
    premium: false,
    favorite: false,
  },
  {
    id: "machine_dips",
    name: "Machine Dips (Upright Torso)",
    category: "Triceps",
    primaryMuscles: ["Triceps"],
    secondaryMuscles: [],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Elbow Extension, Glenohumeral Extension",
    movementPattern: "Elbow Extension",
    equipment: ["Machine"],
    premium: true,
    favorite: true,
  },
  {
    id: "dip_platform",
    name: "Dip Platform (Upright Torso)",
    category: "Triceps",
    primaryMuscles: ["Triceps"],
    secondaryMuscles: [],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Elbow Extension, Glenohumeral Extension",
    movementPattern: "Elbow Extension",
    equipment: ["Dip Station"],
    premium: true,
    favorite: true,
  },
  {
    id: "close_grip_machine_press",
    name: "Flat Close-Grip Machine Tricep Press",
    category: "Triceps",
    primaryMuscles: ["Triceps"],
    secondaryMuscles: [],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Elbow Extension, Glenohumeral Flexion/Adduction",
    movementPattern: "Press",
    equipment: ["Machine"],
    premium: true,
    favorite: true,
  },
  {
    id: "close_grip_db_press",
    name: "Flat Close-Grip DB Tricep Press",
    category: "Triceps",
    primaryMuscles: ["Triceps"],
    secondaryMuscles: [],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Elbow Extension, Glenohumeral Flexion/Adduction",
    movementPattern: "Press",
    equipment: ["Dumbbell", "Bench"],
    premium: true,
    favorite: false,
  },
];
// ======================
// CHEST (PECS)
// ======================

const chestExercises = [
  {
    id: "flat_cable_fly",
    name: "Flat Cable Chest Fly",
    category: "Chest",
    primaryMuscles: ["Sternal Pec"],
    secondaryMuscles: ["Clavicular Pec"],
    romBias: "Lengthened",
    mainTrainingApplication:
      "Scapular Protraction/Retraction, Humeral Adduction",
    movementPattern: "Horizontal Adduction",
    equipment: ["Cable", "Bench"],
    premium: true,
    favorite: false,
  },
  {
    id: "flat_db_fly",
    name: "Flat DB Chest Fly",
    category: "Chest",
    primaryMuscles: ["Sternal Pec"],
    secondaryMuscles: ["Clavicular Pec"],
    romBias: "Lengthened",
    mainTrainingApplication:
      "Scapular Protraction/Retraction, Humeral Adduction",
    movementPattern: "Horizontal Adduction",
    equipment: ["Dumbbell", "Bench"],
    premium: true,
    favorite: false,
  },
  {
    id: "flat_db_press",
    name: "Flat DB Chest Press",
    category: "Chest",
    primaryMuscles: ["Sternal Pec"],
    secondaryMuscles: ["Clavicular Pec", "Triceps"],
    romBias: "Lengthened",
    mainTrainingApplication:
      "Scapular Protraction/Retraction, Humeral Adduction",
    movementPattern: "Press",
    equipment: ["Dumbbell", "Bench"],
    premium: false,
    favorite: true,
  },
  {
    id: "floor_db_press",
    name: "Flat DB Floor Chest Press",
    category: "Chest",
    primaryMuscles: ["Sternal Pec"],
    secondaryMuscles: ["Triceps", "Clavicular Pec"],
    romBias: "Shortened",
    mainTrainingApplication:
      "Scapular Protraction/Retraction, Humeral Adduction",
    movementPattern: "Press",
    equipment: ["Dumbbell", "Floor"],
    premium: false,
    favorite: false,
  },
  {
    id: "flat_bb_press",
    name: "Flat BB Chest Press",
    category: "Chest",
    primaryMuscles: ["Sternal Pec"],
    secondaryMuscles: ["Clavicular Pec", "Triceps"],
    romBias: "Lengthened",
    mainTrainingApplication:
      "Scapular Protraction/Retraction, Humeral Adduction",
    movementPattern: "Press",
    equipment: ["Barbell"],
    premium: true,
    favorite: false,
  },
  {
    id: "floor_bb_press",
    name: "Flat BB Floor Chest Press",
    category: "Chest",
    primaryMuscles: ["Sternal Pec"],
    secondaryMuscles: ["Triceps", "Clavicular Pec"],
    romBias: "Shortened",
    mainTrainingApplication:
      "Scapular Protraction/Retraction, Humeral Adduction",
    movementPattern: "Press",
    equipment: ["Barbell", "Floor"],
    premium: true,
    favorite: false,
  },
  {
    id: "incline_cable_fly",
    name: "Incline Cable Chest Fly",
    category: "Chest",
    primaryMuscles: ["Clavicular Pec"],
    secondaryMuscles: ["Sternal Pec"],
    romBias: "Lengthened",
    mainTrainingApplication:
      "Scapular Protraction/Retraction, Upward/Downward Rotation, Humeral Adduction",
    movementPattern: "Horizontal Adduction",
    equipment: ["Cable", "Bench"],
    premium: true,
    favorite: true,
  },
  {
    id: "incline_db_fly",
    name: "Incline DB Chest Fly",
    category: "Chest",
    primaryMuscles: ["Clavicular Pec"],
    secondaryMuscles: ["Sternal Pec"],
    romBias: "Lengthened",
    mainTrainingApplication:
      "Scapular Protraction/Retraction, Upward/Downward Rotation, Humeral Adduction",
    movementPattern: "Horizontal Adduction",
    equipment: ["Dumbbell", "Bench"],
    premium: true,
    favorite: false,
  },
  {
    id: "incline_db_press",
    name: "Incline DB Chest Press",
    category: "Chest",
    primaryMuscles: ["Clavicular Pec"],
    secondaryMuscles: ["Sternal Pec", "Triceps"],
    romBias: "Lengthened",
    mainTrainingApplication:
      "Scapular Protraction/Retraction, Upward/Downward Rotation, Humeral Adduction",
    movementPattern: "Press",
    equipment: ["Dumbbell", "Bench"],
    premium: false,
    favorite: false,
  },
  {
    id: "incline_bb_press",
    name: "Incline BB Chest Press",
    category: "Chest",
    primaryMuscles: ["Clavicular Pec"],
    secondaryMuscles: ["Sternal Pec", "Triceps"],
    romBias: "Lengthened",
    mainTrainingApplication:
      "Scapular Protraction/Retraction, Upward/Downward Rotation, Humeral Adduction",
    movementPattern: "Press",
    equipment: ["Barbell"],
    premium: true,
    favorite: false,
  },
  {
    id: "incline_smith_underhand_press",
    name: "Incline Smith Machine Underhand Chest Press",
    category: "Chest",
    primaryMuscles: ["Clavicular Pec"],
    secondaryMuscles: ["Sternal Pec"],
    romBias: "Lengthened",
    mainTrainingApplication:
      "Scapular Protraction/Retraction, Upward/Downward Rotation, Humeral Adduction",
    movementPattern: "Press",
    equipment: ["Smith Machine"],
    premium: true,
    favorite: true,
  },
  {
    id: "machine_flat_press",
    name: "Flat Machine Chest Press",
    category: "Chest",
    primaryMuscles: ["Sternal Pec"],
    secondaryMuscles: ["Clavicular Pec", "Triceps"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication:
      "Scapular Protraction/Retraction, Humeral Adduction",
    movementPattern: "Press",
    equipment: ["Machine"],
    premium: true,
    favorite: true,
  },
  {
    id: "machine_incline_press",
    name: "Incline Machine Chest Press",
    category: "Chest",
    primaryMuscles: ["Clavicular Pec"],
    secondaryMuscles: ["Sternal Pec", "Triceps"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication:
      "Scapular Protraction/Retraction, Upward/Downward Rotation, Humeral Adduction",
    movementPattern: "Press",
    equipment: ["Machine"],
    premium: true,
    favorite: true,
  },
  {
    id: "cable_press_around_mid",
    name: "Cable Press-Around (Mid)",
    category: "Chest",
    primaryMuscles: ["Sternal Pec"],
    secondaryMuscles: ["Clavicular Pec"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication:
      "Scapular Protraction/Retraction, Humeral Adduction",
    movementPattern: "Horizontal Adduction",
    equipment: ["Cable"],
    premium: true,
    favorite: true,
  },
  {
    id: "cable_press_around_high_low",
    name: "Cable Press-Around (High-to-Low)",
    category: "Chest",
    primaryMuscles: ["Costal Pec"],
    secondaryMuscles: ["Sternal Pec"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication:
      "Scapular Protraction/Retraction, Upward/Downward Rotation, Humeral Adduction",
    movementPattern: "Horizontal Adduction",
    equipment: ["Cable"],
    premium: true,
    favorite: false,
  },
  {
    id: "cable_press_around_low_high",
    name: "Cable Press-Around (Low-to-High)",
    category: "Chest",
    primaryMuscles: ["Clavicular Pec"],
    secondaryMuscles: ["Sternal Pec"],
    romBias: "Shortened",
    mainTrainingApplication:
      "Scapular Protraction/Retraction, Upward/Downward Rotation, Humeral Adduction",
    movementPattern: "Horizontal Adduction",
    equipment: ["Cable"],
    premium: true,
    favorite: false,
  },
  {
    id: "machine_dips_forward",
    name: "Machine Dips (Leaning Forward)",
    category: "Chest",
    primaryMuscles: ["Costal Pec"],
    secondaryMuscles: ["Triceps"],
    romBias: "Lengthened",
    mainTrainingApplication:
      "Scapular Protraction/Retraction, Elevation/Depression, Humeral Adduction",
    movementPattern: "Press",
    equipment: ["Machine"],
    premium: true,
    favorite: true,
  },
  {
    id: "dip_platform_forward",
    name: "Dip Platform (Leaning Forward)",
    category: "Chest",
    primaryMuscles: ["Costal Pec"],
    secondaryMuscles: ["Triceps"],
    romBias: "Lengthened",
    mainTrainingApplication:
      "Scapular Protraction/Retraction, Elevation/Depression, Humeral Adduction",
    movementPattern: "Press",
    equipment: ["Dip Station"],
    premium: true,
    favorite: true,
  },
  {
    id: "pec_dec_fly",
    name: "Pec Deck Machine Fly",
    category: "Chest",
    primaryMuscles: ["Sternal Pec"],
    secondaryMuscles: ["Costal/Clavicular Pec"],
    romBias: "Shortened",
    mainTrainingApplication:
      "Scapular Protraction/Retraction, Humeral Adduction",
    movementPattern: "Horizontal Adduction",
    equipment: ["Machine"],
    premium: false,
    favorite: false,
  },
  {
    id: "pec_dec_incline",
    name: "Pec Deck Machine Fly (Incline Focused)",
    category: "Chest",
    primaryMuscles: ["Clavicular Pec"],
    secondaryMuscles: ["Sternal Pec"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication:
      "Scapular Protraction/Retraction, Humeral Adduction",
    movementPattern: "Horizontal Adduction",
    equipment: ["Machine"],
    premium: true,
    favorite: false,
  },
  {
    id: "pushup_standard",
    name: "Push-Ups Standard",
    category: "Chest",
    primaryMuscles: ["Sternal Pec"],
    secondaryMuscles: ["Clavicular/Costal Pec", "Triceps"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication:
      "Scapular Protraction/Retraction, Humeral Adduction",
    movementPattern: "Press",
    equipment: ["Bodyweight"],
    premium: false,
    favorite: false,
  },
  {
    id: "pushup_decline",
    name: "Push-Ups (Decline)",
    category: "Chest",
    primaryMuscles: ["Clavicular Pec"],
    secondaryMuscles: ["Sternal Pec", "Triceps"],
    romBias: "Shortened",
    mainTrainingApplication:
      "Scapular Protraction/Retraction, Upward/Downward Rotation, Humeral Adduction",
    movementPattern: "Press",
    equipment: ["Bodyweight"],
    premium: true,
    favorite: false,
  },
  {
    id: "pushup_incline",
    name: "Push-Ups (Incline)",
    category: "Chest",
    primaryMuscles: ["Costal Pec"],
    secondaryMuscles: ["Sternal/Clavicular Pec"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication:
      "Scapular Protraction/Retraction, Elevation/Depression, Humeral Adduction",
    movementPattern: "Press",
    equipment: ["Bodyweight"],
    premium: true,
    favorite: false,
  },
];
// ======================
// LATS
// ======================

const latExercises = [
  {
    id: "pullups_overhand",
    name: "Pull-Ups (Overhand Grip)",
    category: "Lats",
    primaryMuscles: ["Lats"],
    secondaryMuscles: ["Teres Major", "Rhomboids", "Traps", "Brachialis"],
    romBias: "Shortened",
    mainTrainingApplication:
      "Scapular Elevation/ Depression, Upward/Downward Rotation, Humeral Adduction/Extension",
    movementPattern: "Vertical Pull",
    equipment: ["Bodyweight", "Pull-Up Bar"],
    premium: false,
    favorite: false,
  },
  {
    id: "chinups_underhand",
    name: "Chin-Ups (Underhand Grip)",
    category: "Lats",
    primaryMuscles: ["Lats"],
    secondaryMuscles: ["Biceps", "Teres Major", "Traps"],
    romBias: "Shortened",
    mainTrainingApplication:
      "Scapular Elevation/ Depression, Upward/Downward Rotation, Humeral Adduction/Extension",
    movementPattern: "Vertical Pull",
    equipment: ["Bodyweight", "Pull-Up Bar"],
    premium: true,
    favorite: false,
  },
  {
    id: "pullups_neutral",
    name: "Pull-Ups (Neutral Grip)",
    category: "Lats",
    primaryMuscles: ["Lats"],
    secondaryMuscles: ["Biceps", "Brachialis", "Traps"],
    romBias: "Shortened",
    mainTrainingApplication:
      "Scapular Elevation/ Depression, Upward/Downward Rotation, Humeral Adduction/Extension",
    movementPattern: "Vertical Pull",
    equipment: ["Bodyweight"],
    premium: true,
    favorite: false,
  },
  {
    id: "band_assisted_pullups",
    name: "Band-Assisted Pull-Ups",
    category: "Lats",
    primaryMuscles: ["Lats"],
    secondaryMuscles: ["Teres Major", "Traps"],
    romBias: "Shortened",
    mainTrainingApplication:
      "Scapular Elevation/ Depression, Upward/Downward Rotation, Humeral Adduction/Extension",
    movementPattern: "Vertical Pull",
    equipment: ["Band", "Bodyweight"],
    premium: true,
    favorite: false,
  },
  {
    id: "machine_pullups",
    name: "Machine Pull-Ups",
    category: "Lats",
    primaryMuscles: ["Lats"],
    secondaryMuscles: ["Teres Major", "Traps"],
    romBias: "Shortened",
    mainTrainingApplication:
      "Scapular Elevation/ Depression, Upward/Downward Rotation, Humeral Adduction/Extension",
    movementPattern: "Vertical Pull",
    equipment: ["Machine"],
    premium: true,
    favorite: false,
  },
  {
    id: "wide_cable_lat_pulldown",
    name: "Wide-Grip Cable Lat Pulldown",
    category: "Lats",
    primaryMuscles: ["Lats"],
    secondaryMuscles: ["Rhomboids", "Traps"],
    romBias: "Shortened",
    mainTrainingApplication:
      "Scapular Elevation/ Depression, Upward/Downward Rotation, Humeral Adduction/Extension",
    movementPattern: "Vertical Pull",
    equipment: ["Cable"],
    premium: false,
    favorite: true,
  },
  {
    id: "wide_machine_lat_pulldown",
    name: "Wide-Grip Machine Lat Pulldown",
    category: "Lats",
    primaryMuscles: ["Lats"],
    secondaryMuscles: ["Rhomboids", "Traps"],
    romBias: "Shortened",
    mainTrainingApplication:
      "Scapular Elevation/ Depression, Upward/Downward Rotation, Humeral Adduction/Extension",
    movementPattern: "Vertical Pull",
    equipment: ["Machine"],
    premium: true,
    favorite: false,
  },
  {
    id: "single_arm_cable_pulldown",
    name: "Single-Arm Cable Lat Pulldown",
    category: "Lats",
    primaryMuscles: ["Thoracic Lats"],
    secondaryMuscles: ["Rhomboids", "Traps"],
    romBias: "Shortened",
    mainTrainingApplication:
      "Scapular Elevation/ Depression, Upward/Downward Rotation, Humeral Adduction/Extension",
    movementPattern: "Vertical Pull",
    equipment: ["Cable"],
    premium: true,
    favorite: true,
  },
  {
    id: "band_lat_pulldown",
    name: "Band Lat Pulldown",
    category: "Lats",
    primaryMuscles: ["Lats"],
    secondaryMuscles: [],
    romBias: "Shortened",
    mainTrainingApplication:
      "Scapular Elevation/ Depression, Upward/Downward Rotation, Humeral Adduction/Extension",
    movementPattern: "Vertical Pull",
    equipment: ["Band"],
    premium: true,
    favorite: false,
  },
  {
    id: "thoracic_machine_row",
    name: "Thoracic Lat Machine Row",
    category: "Lats",
    primaryMuscles: ["Thoracic Lats"],
    secondaryMuscles: ["Rhomboids", "Traps"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication:
      "Scapular Elevation/Depression, Protraction/Retraction, Humeral Adduction/Extension",
    movementPattern: "Row",
    equipment: ["Machine"],
    premium: true,
    favorite: true,
  },
  {
    id: "thoracic_cable_row",
    name: "Thoracic Lat Cable Row",
    category: "Lats",
    primaryMuscles: ["Thoracic Lats"],
    secondaryMuscles: ["Rhomboids", "Traps"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication:
      "Scapular Elevation/Depression, Protraction/Retraction, Humeral Adduction/Extension",
    movementPattern: "Row",
    equipment: ["Cable"],
    premium: true,
    favorite: true,
  },
  {
    id: "lumbar_lat_pullaround_cable",
    name: "Lumbar Lat Pull-Around (Cable)",
    category: "Lats",
    primaryMuscles: ["Lumbar Lats"],
    secondaryMuscles: ["Rhomboids", "Traps"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication:
      "Scapular Elevation/ Depression, Upward/Downward Rotation, Humeral Adduction/Extension",
    movementPattern: "Shoulder Extension",
    equipment: ["Cable"],
    premium: true,
    favorite: true,
  },
  {
    id: "iliac_lat_pullaround_cable",
    name: "Iliac Lat Pull-Around (Cable)",
    category: "Lats",
    primaryMuscles: ["Iliac Lats"],
    secondaryMuscles: ["Rhomboids", "Traps"],
    romBias: "Lengthened",
    mainTrainingApplication:
      "Scapular Elevation/ Depression, Upward/Downward Rotation, Humeral Adduction/Extension",
    movementPattern: "Shoulder Extension",
    equipment: ["Cable"],
    premium: true,
    favorite: true,
  },
  {
    id: "lat_pullover_rope",
    name: "Cable Lat Pullover (Rope)",
    category: "Lats",
    primaryMuscles: ["Lats"],
    secondaryMuscles: ["Teres Major"],
    romBias: "Shortened",
    mainTrainingApplication:
      "Scapular Elevation/ Depression, Upward/Downward Rotation, Humeral Adduction/Extension",
    movementPattern: "Shoulder Extension",
    equipment: ["Cable"],
    premium: true,
    favorite: false,
  },
  {
    id: "lat_pullover_db",
    name: "Dumbbell Lat Pullover",
    category: "Lats",
    primaryMuscles: ["Lats"],
    secondaryMuscles: ["Teres Major"],
    romBias: "Lengthened",
    mainTrainingApplication:
      "Scapular Elevation/ Depression, Upward/Downward Rotation, Humeral Adduction/Extension",
    movementPattern: "Shoulder Extension",
    equipment: ["Dumbbell"],
    premium: true,
    favorite: false,
  },
  {
    id: "machine_lat_pullover",
    name: "Machine Lat Pullover",
    category: "Lats",
    primaryMuscles: ["Lats"],
    secondaryMuscles: ["Teres Major"],
    romBias: "Lengthened",
    mainTrainingApplication:
      "Scapular Elevation/ Depression, Upward/Downward Rotation, Humeral Adduction/Extension",
    movementPattern: "Shoulder Extension",
    equipment: ["Machine"],
    premium: true,
    favorite: false,
  },
  {
    id: "single_arm_db_row",
    name: "Single-Arm DB Row (Elbows Tucked)",
    category: "Lats",
    primaryMuscles: ["Lats"],
    secondaryMuscles: ["Rhomboids", "Traps"],
    romBias: "Shortened",
    mainTrainingApplication:
      "Scapular Elevation/Depression, Protraction/Retraction, Humeral Adduction/Extension",
    movementPattern: "Row",
    equipment: ["Dumbbell"],
    premium: true,
    favorite: false,
  },
  {
    id: "chest_supported_cable_row_tucked",
    name: "Chest-Supported Cable Row with Elbows Tucked",
    category: "Lats",
    primaryMuscles: ["Lats"],
    secondaryMuscles: ["Rhomboids", "Traps", "Posterior Delt"],
    romBias: "Shortened",
    mainTrainingApplication:
      "Scapular Elevation/Depression, Protraction/Retraction, Humeral Adduction/Extension",
    movementPattern: "Row",
    equipment: ["Cable"],
    premium: true,
    favorite: true,
  },
  {
    id: "chest_supported_machine_row_tucked",
    name: "Chest-Supported Machine Row with Elbows Tucked",
    category: "Lats",
    primaryMuscles: ["Lats"],
    secondaryMuscles: ["Rhomboids", "Traps", "Posterior Delt"],
    romBias: "Shortened",
    mainTrainingApplication:
      "Scapular Elevation/Depression, Protraction/Retraction, Humeral Adduction/Extension",
    movementPattern: "Row",
    equipment: ["Machine"],
    premium: true,
    favorite: true,
  },
  {
    id: "band_row_tucked",
    name: "Band Row with Elbows Tucked",
    category: "Lats",
    primaryMuscles: ["Lats"],
    secondaryMuscles: ["Rhomboids", "Traps", "Posterior Delt"],
    romBias: "Shortened",
    mainTrainingApplication:
      "Scapular Elevation/Depression, Protraction/Retraction, Humeral Adduction/Extension",
    movementPattern: "Row",
    equipment: ["Band"],
    premium: false,
    favorite: false,
  },
  {
    id: "barbell_row_tucked",
    name: "Barbell Row (Elbows Tucked)",
    category: "Lats",
    primaryMuscles: ["Lats"],
    secondaryMuscles: ["Erectors", "Rhomboids"],
    romBias: "Shortened",
    mainTrainingApplication:
      "Scapular Elevation/Depression, Protraction/Retraction, Humeral Adduction/Extension",
    movementPattern: "Row",
    equipment: ["Barbell"],
    premium: true,
    favorite: true,
  },
  {
    id: "landmine_row",
    name: "Landmine Barbell Row",
    category: "Lats",
    primaryMuscles: ["Lats"],
    secondaryMuscles: ["Erectors", "Rhomboids"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication:
      "Scapular Elevation/Depression, Protraction/Retraction, Humeral Adduction/Extension",
    movementPattern: "Row",
    equipment: ["Barbell"],
    premium: true,
    favorite: false,
  },
  {
    id: "tbar_row",
    name: "Neutral-Grip T-Bar Row",
    category: "Lats",
    primaryMuscles: ["Lats"],
    secondaryMuscles: ["Erectors", "Rhomboids"],
    romBias: "Shortened",
    mainTrainingApplication:
      "Scapular Elevation/Depression, Protraction/Retraction, Humeral Adduction/Extension",
    movementPattern: "Row",
    equipment: ["T-Bar Station"],
    premium: true,
    favorite: false,
  },
];
// ======================
// TRAPS
// ======================

const trapExercises = [
  {
    id: "band_row_elbows_flared",
    name: "Band Row with Elbows Flared",
    category: "Traps",
    primaryMuscles: ["Mid Traps"],
    secondaryMuscles: ["Rhomboids", "Posterior Deltoids"],
    romBias: "Shortened",
    mainTrainingApplication:
      "Scapular Retraction, Depression, Humeral Horizontal Abduction",
    movementPattern: "Row",
    equipment: ["Band"],
    premium: false,
    favorite: false,
  },
  {
    id: "bent_over_barbell_row_elbows_flared",
    name: "Bent Over Barbell Row with Elbows Flared",
    category: "Traps",
    primaryMuscles: ["Mid Traps"],
    secondaryMuscles: ["Rhomboids", "Erectors"],
    romBias: "Shortened",
    mainTrainingApplication:
      "Scapular Retraction, Depression, Humeral Horizontal Abduction",
    movementPattern: "Row",
    equipment: ["Barbell"],
    premium: true,
    favorite: true,
  },
  {
    id: "bent_over_dumbbell_row_elbows_flared",
    name: "Bent Over Dumbbell Row with Elbows Flared",
    category: "Traps",
    primaryMuscles: ["Mid Traps"],
    secondaryMuscles: ["Rhomboids", "Erectors"],
    romBias: "Shortened",
    mainTrainingApplication:
      "Scapular Retraction, Depression, Humeral Horizontal Abduction",
    movementPattern: "Row",
    equipment: ["Dumbbell"],
    premium: true,
    favorite: true,
  },
  {
    id: "chest_supported_db_row_elbows_flared",
    name: "Chest-Supported DB Row Elbows Flared",
    category: "Traps",
    primaryMuscles: ["Mid Traps"],
    secondaryMuscles: ["Rhomboids", "Posterior Deltoids"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication:
      "Scapular Retraction, Depression, Humeral Horizontal Abduction",
    movementPattern: "Row",
    equipment: ["Adjustable Bench", "Dumbbell"],
    premium: true,
    favorite: true,
  },
  {
    id: "chest_supported_machine_row_elbows_flared",
    name: "Chest-Supported Machine Row Elbows Flared",
    category: "Traps",
    primaryMuscles: ["Mid Traps"],
    secondaryMuscles: ["Rhomboids", "Posterior Deltoids"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication:
      "Scapular Retraction, Depression, Humeral Horizontal Abduction",
    movementPattern: "Row",
    equipment: ["Machine"],
    premium: true,
    favorite: true,
  },
  {
    id: "pendlay_barbell_row",
    name: "Pendlay Barbell Row",
    category: "Traps",
    primaryMuscles: ["Mid Traps"],
    secondaryMuscles: ["Rhomboids", "Erectors"],
    romBias: "Shortened",
    mainTrainingApplication:
      "Scapular Retraction, Depression, Humeral Horizontal Abduction",
    movementPattern: "Row",
    equipment: ["Barbell"],
    premium: true,
    favorite: false,
  },
  {
    id: "dumbbell_seal_row",
    name: "Dumbbell Seal Row",
    category: "Traps",
    primaryMuscles: ["Mid Traps"],
    secondaryMuscles: ["Rhomboids", "Posterior Deltoids"],
    romBias: "Shortened",
    mainTrainingApplication:
      "Scapular Retraction, Depression, Humeral Horizontal Abduction",
    movementPattern: "Row",
    equipment: ["Adjustable Bench", "Dumbbell"],
    premium: true,
    favorite: false,
  },
  {
    id: "barbell_seal_row",
    name: "Barbell Seal Row",
    category: "Traps",
    primaryMuscles: ["Mid Traps"],
    secondaryMuscles: ["Rhomboids", "Posterior Deltoids"],
    romBias: "Shortened",
    mainTrainingApplication:
      "Scapular Retraction, Depression, Humeral Horizontal Abduction",
    movementPattern: "Row",
    equipment: ["Adjustable Bench", "Barbell"],
    premium: true,
    favorite: false,
  },
  {
    id: "wide_grip_seated_cable_row",
    name: "Wide-Grip Seated Cable Row",
    category: "Traps",
    primaryMuscles: ["Mid Traps"],
    secondaryMuscles: ["Rhomboids", "Posterior Deltoids", "Erectors"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication:
      "Scapular Retraction, Depression, Humeral Horizontal Abduction",
    movementPattern: "Row",
    equipment: ["Cable"],
    premium: false,
    favorite: false,
  },
  {
    id: "wide_grip_seated_machine_row",
    name: "Wide-Grip Seated Machine Row",
    category: "Traps",
    primaryMuscles: ["Mid Traps"],
    secondaryMuscles: ["Rhomboids", "Posterior Deltoids"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication:
      "Scapular Retraction, Depression, Humeral Horizontal Abduction",
    movementPattern: "Row",
    equipment: ["Machine"],
    premium: true,
    favorite: true,
  },
  {
    id: "neutral_grip_seated_cable_row",
    name: "Neutral-Grip Seated Cable Row",
    category: "Traps",
    primaryMuscles: ["Mid Traps"],
    secondaryMuscles: ["Rhomboids", "Posterior Deltoids", "Erectors"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication:
      "Scapular Retraction, Depression, Humeral Horizontal Abduction",
    movementPattern: "Row",
    equipment: ["Cable"],
    premium: true,
    favorite: true,
  },
  {
    id: "neutral_grip_seated_machine_row",
    name: "Neutral-Grip Seated Machine Row",
    category: "Traps",
    primaryMuscles: ["Mid Traps"],
    secondaryMuscles: ["Rhomboids", "Posterior Deltoids"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication:
      "Scapular Retraction, Depression, Humeral Horizontal Abduction",
    movementPattern: "Row",
    equipment: ["Machine"],
    premium: true,
    favorite: true,
  },
  {
    id: "reclined_high_cable_pulldown",
    name: "Reclined High Cable Pulldown",
    category: "Traps",
    primaryMuscles: ["Mid Traps"],
    secondaryMuscles: ["Rhomboids", "Posterior Deltoids"],
    romBias: "Shortened",
    mainTrainingApplication:
      "Scapular Retraction, Depression, Humeral Horizontal Abduction",
    movementPattern: "Pulldown",
    equipment: ["Cable", "Pulldown Station"],
    premium: true,
    favorite: false,
  },
  {
    id: "wide_grip_t_bar_row",
    name: "Wide-Grip T-Bar Row",
    category: "Traps",
    primaryMuscles: ["Mid Traps"],
    secondaryMuscles: ["Rhomboids", "Posterior Deltoids"],
    romBias: "Shortened",
    mainTrainingApplication:
      "Scapular Retraction, Depression, Humeral Horizontal Abduction",
    movementPattern: "Row",
    equipment: ["T-Bar Station"],
    premium: true,
    favorite: true,
  },
  {
    id: "meadows_row",
    name: "Meadows Row",
    category: "Traps",
    primaryMuscles: ["Mid Traps"],
    secondaryMuscles: ["Rhomboids", "Posterior Deltoids", "Erectors"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication:
      "Scapular Retraction, Depression, Humeral Horizontal Abduction",
    movementPattern: "Row",
    equipment: ["Barbell"],
    premium: true,
    favorite: false,
  },
  {
    id: "dumbbell_shrugs",
    name: "Dumbbell Shrugs",
    category: "Traps",
    primaryMuscles: ["Upper Traps"],
    secondaryMuscles: ["Abs", "Erectors"],
    romBias: "Shortened",
    mainTrainingApplication: "Scapular Elevation, Upward/Downward Rotation",
    movementPattern: "Shrug",
    equipment: ["Dumbbell"],
    premium: false,
    favorite: false,
  },
  {
    id: "barbell_shrugs",
    name: "Barbell Shrugs",
    category: "Traps",
    primaryMuscles: ["Upper Traps"],
    secondaryMuscles: ["Abs", "Erectors"],
    romBias: "Shortened",
    mainTrainingApplication: "Scapular Elevation, Upward/Downward Rotation",
    movementPattern: "Shrug",
    equipment: ["Barbell"],
    premium: true,
    favorite: false,
  },
  {
    id: "machine_shrugs",
    name: "Machine Shrugs",
    category: "Traps",
    primaryMuscles: ["Upper Traps"],
    secondaryMuscles: ["Abs", "Erectors"],
    romBias: "Shortened",
    mainTrainingApplication: "Scapular Elevation, Upward/Downward Rotation",
    movementPattern: "Shrug",
    equipment: ["Machine"],
    premium: true,
    favorite: true,
  },
  {
    id: "cable_shrugs",
    name: "Cable Shrugs",
    category: "Traps",
    primaryMuscles: ["Upper Traps"],
    secondaryMuscles: ["Abs", "Erectors"],
    romBias: "Shortened",
    mainTrainingApplication: "Scapular Elevation, Upward/Downward Rotation",
    movementPattern: "Shrug",
    equipment: ["Cable"],
    premium: true,
    favorite: true,
  },
];
// ======================
// QUADS
// ======================

const quadExercises = [
  {
    id: "barbell_back_squat",
    name: "Barbell Back Squat",
    category: "Quads",
    primaryMuscles: ["Quadriceps"],
    secondaryMuscles: ["Glutes", "Adductors", "Erectors/Abs"],
    romBias: "Lengthened",
    mainTrainingApplication: "Knee Extension, Hip Flexion/Extension",
    movementPattern: "Squat",
    equipment: ["Barbell", "Squat Rack Station"],
    premium: false,
    favorite: false,
  },
  {
    id: "barbell_back_squat_heels_elevated",
    name: "Barbell Back Squat Heels Elevated (10-20 Degrees)",
    category: "Quads",
    primaryMuscles: ["Quadriceps"],
    secondaryMuscles: ["Glutes", "Adductors", "Erectors/Abs"],
    romBias: "Lengthened",
    mainTrainingApplication: "Knee Extension, Hip Flexion/Extension",
    movementPattern: "Squat",
    equipment: ["Barbell", "Squat Rack Station", "Heels/Wedges"],
    premium: true,
    favorite: false,
  },
  {
    id: "safety_bar_squat",
    name: "Safety Bar Squat",
    category: "Quads",
    primaryMuscles: ["Quadriceps"],
    secondaryMuscles: ["Glutes", "Adductors", "Erectors/Abs"],
    romBias: "Lengthened",
    mainTrainingApplication: "Knee Extension, Hip Flexion/Extension",
    movementPattern: "Squat",
    equipment: ["Safety Bar", "Squat Rack Station"],
    premium: true,
    favorite: false,
  },
  {
    id: "safety_bar_squat_heels_elevated",
    name: "Safety Bar Squat Heels Elevated (10-20 Degree)",
    category: "Quads",
    primaryMuscles: ["Quadriceps"],
    secondaryMuscles: ["Glutes", "Adductors", "Erectors/Abs"],
    romBias: "Lengthened",
    mainTrainingApplication: "Knee Extension, Hip Flexion/Extension",
    movementPattern: "Squat",
    equipment: ["Safety Bar", "Squat Rack Station", "Heels/Wedges"],
    premium: true,
    favorite: false,
  },
  {
    id: "safety_bar_hatfield_squat",
    name: "Safety Bar Hatfield Squat",
    category: "Quads",
    primaryMuscles: ["Quadriceps"],
    secondaryMuscles: ["Glutes", "Adductors", "Erectors/Abs"],
    romBias: "Lengthened",
    mainTrainingApplication: "Knee Extension, Hip Flexion/Extension",
    movementPattern: "Squat",
    equipment: ["Safety Bar", "Squat Rack Station"],
    premium: true,
    favorite: true,
  },
  {
    id: "barbell_front_squat",
    name: "Barbell Front Squat",
    category: "Quads",
    primaryMuscles: ["Quadriceps"],
    secondaryMuscles: ["Glutes", "Adductors", "Erectors/Abs"],
    romBias: "Lengthened",
    mainTrainingApplication: "Knee Extension, Hip Flexion/Extension",
    movementPattern: "Squat",
    equipment: ["Barbell", "Squat Rack Station"],
    premium: true,
    favorite: false,
  },
  {
    id: "barbell_front_squat_heels_elevated",
    name: "Barbell Front Squat Heels Elevated (10-20 Degrees)",
    category: "Quads",
    primaryMuscles: ["Quadriceps"],
    secondaryMuscles: ["Glutes", "Adductors", "Erectors/Abs"],
    romBias: "Lengthened",
    mainTrainingApplication: "Knee Extension, Hip Flexion/Extension",
    movementPattern: "Squat",
    equipment: ["Barbell", "Squat Rack Station", "Heels/Wedges"],
    premium: true,
    favorite: false,
  },
  {
    id: "cable_front_squat",
    name: "Cable Front Squat",
    category: "Quads",
    primaryMuscles: ["Quadriceps"],
    secondaryMuscles: ["Glutes", "Adductors", "Erectors/Abs"],
    romBias: "Lengthened",
    mainTrainingApplication: "Knee Extension, Hip Flexion/Extension",
    movementPattern: "Squat",
    equipment: ["Cable"],
    premium: false,
    favorite: false,
  },
  {
    id: "cable_front_squat_heels_elevated",
    name: "Cable Front Squat Heels Elevated (10-20 Degrees)",
    category: "Quads",
    primaryMuscles: ["Quadriceps"],
    secondaryMuscles: ["Glutes", "Adductors", "Erectors/Abs"],
    romBias: "Lengthened",
    mainTrainingApplication: "Knee Extension, Hip Flexion/Extension",
    movementPattern: "Squat",
    equipment: ["Cable", "Heels/Wedges"],
    premium: true,
    favorite: false,
  },
  {
    id: "dumbbell_goblet_squat",
    name: "Dumbbell Goblet Squat",
    category: "Quads",
    primaryMuscles: ["Quadriceps"],
    secondaryMuscles: ["Glutes", "Adductors", "Erectors/Abs"],
    romBias: "Lengthened",
    mainTrainingApplication: "Knee Extension, Hip Flexion/Extension",
    movementPattern: "Squat",
    equipment: ["Dumbbell"],
    premium: true,
    favorite: false,
  },
  {
    id: "dumbbell_goblet_squat_heels_elevated",
    name: "Dumbbell Goblet Squat Heels Elevated (10-20 Degrees)",
    category: "Quads",
    primaryMuscles: ["Quadriceps"],
    secondaryMuscles: ["Glutes", "Adductors", "Erectors/Abs"],
    romBias: "Lengthened",
    mainTrainingApplication: "Knee Extension, Hip Flexion/Extension",
    movementPattern: "Squat",
    equipment: ["Dumbbell", "Heels/Wedges"],
    premium: true,
    favorite: false,
  },
  {
    id: "front_squat_machine",
    name: "Front Squat Machine",
    category: "Quads",
    primaryMuscles: ["Quadriceps"],
    secondaryMuscles: ["Glutes", "Adductors", "Erectors/Abs"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Knee Extension, Hip Flexion/Extension",
    movementPattern: "Squat",
    equipment: ["Machine"],
    premium: true,
    favorite: true,
  },
  {
    id: "squat_machine",
    name: "Squat Machine",
    category: "Quads",
    primaryMuscles: ["Quadriceps"],
    secondaryMuscles: ["Glutes", "Adductors", "Erectors/Abs"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Knee Extension, Hip Flexion/Extension",
    movementPattern: "Squat",
    equipment: ["Machine"],
    premium: true,
    favorite: false,
  },
  {
    id: "pendulum_squat",
    name: "Pendulum Squat",
    category: "Quads",
    primaryMuscles: ["Quadriceps"],
    secondaryMuscles: ["Glutes", "Adductors", "Erectors/Abs"],
    romBias: "Lengthened",
    mainTrainingApplication: "Knee Extension, Hip Flexion/Extension",
    movementPattern: "Squat",
    equipment: ["Machine"],
    premium: true,
    favorite: true,
  },
  {
    id: "hack_squat_feet_narrow",
    name: "Hack Squat Feet Narrow",
    category: "Quads",
    primaryMuscles: ["Quadriceps"],
    secondaryMuscles: ["Glutes", "Adductors", "Erectors/Abs"],
    romBias: "Lengthened",
    mainTrainingApplication: "Knee Extension, Hip Flexion/Extension",
    movementPattern: "Squat",
    equipment: ["Machine"],
    premium: true,
    favorite: true,
  },
  {
    id: "belt_squat",
    name: "Belt Squat",
    category: "Quads",
    primaryMuscles: ["Quadriceps"],
    secondaryMuscles: ["Glutes", "Adductors", "Erectors/Abs"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Knee Extension, Hip Flexion/Extension",
    movementPattern: "Squat",
    equipment: ["Belt", "Machine"],
    premium: true,
    favorite: true,
  },
  {
    id: "leg_press_feet_low",
    name: "Leg Press Feet Low",
    category: "Quads",
    primaryMuscles: ["Quadriceps"],
    secondaryMuscles: ["Glutes", "Adductors", "Erectors/Abs"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Knee Extension, Hip Flexion/Extension",
    movementPattern: "Leg Press",
    equipment: ["Leg Press Station"],
    premium: true,
    favorite: false,
  },
  {
    id: "single_leg_leg_press_feet_low",
    name: "Single-Leg Leg Press Feet Low",
    category: "Quads",
    primaryMuscles: ["Quadriceps"],
    secondaryMuscles: ["Glutes", "Adductors", "Erectors/Abs"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Knee Extension, Hip Flexion/Extension",
    movementPattern: "Leg Press",
    equipment: ["Leg Press Station"],
    premium: true,
    favorite: false,
  },
  {
    id: "step_up_knee_over_toe_with_db",
    name: "Step-Up Knee Over Toe with DB",
    category: "Quads",
    primaryMuscles: ["Quadriceps"],
    secondaryMuscles: ["Glutes", "Adductors", "Erectors/Abs"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Knee Extension, Hip Flexion/Extension",
    movementPattern: "Step-Up",
    equipment: ["Adjustable Bench", "Dumbbell"],
    premium: false,
    favorite: false,
  },
  {
    id: "step_up_knee_over_toe_with_cable",
    name: "Step-Up Knee Over Toe with Cable",
    category: "Quads",
    primaryMuscles: ["Quadriceps"],
    secondaryMuscles: ["Glutes", "Adductors", "Erectors/Abs"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Knee Extension, Hip Flexion/Extension",
    movementPattern: "Step-Up",
    equipment: ["Adjustable Bench", "Cable"],
    premium: true,
    favorite: false,
  },
  {
    id: "split_squat_feet_narrow_with_db",
    name: "Split Squat Feet Narrow with DB",
    category: "Quads",
    primaryMuscles: ["Quadriceps"],
    secondaryMuscles: ["Glutes", "Adductors", "Erectors/Abs"],
    romBias: "Lengthened",
    mainTrainingApplication: "Knee Extension, Hip Flexion/Extension",
    movementPattern: "Split Squat",
    equipment: ["Dumbbell"],
    premium: true,
    favorite: false,
  },
  {
    id: "split_squat_dual_heels_elevated_with_db",
    name: "Split Squat Dual Heels Elevated (10-20 Degrees) with DB",
    category: "Quads",
    primaryMuscles: ["Quadriceps"],
    secondaryMuscles: ["Glutes", "Adductors", "Erectors/Abs"],
    romBias: "Lengthened",
    mainTrainingApplication: "Knee Extension, Hip Flexion/Extension",
    movementPattern: "Split Squat",
    equipment: ["Dumbbell", "Wedges"],
    premium: true,
    favorite: true,
  },
  {
    id: "bulgarian_db_split_squat_feet_closer",
    name: "Bulgarian DB Split Squat Feet Closer",
    category: "Quads",
    primaryMuscles: ["Quadriceps"],
    secondaryMuscles: ["Glutes", "Adductors", "Erectors/Abs"],
    romBias: "Lengthened",
    mainTrainingApplication: "Knee Extension, Hip Flexion/Extension",
    movementPattern: "Split Squat",
    equipment: ["Adjustable Bench", "Dumbbell"],
    premium: true,
    favorite: false,
  },
  {
    id: "bulgarian_db_split_squat_heel_elevated",
    name: "Bulgarian DB Split Squat Heel Elevated (10-20 Degrees)",
    category: "Quads",
    primaryMuscles: ["Quadriceps"],
    secondaryMuscles: ["Glutes", "Adductors", "Erectors/Abs"],
    romBias: "Lengthened",
    mainTrainingApplication: "Knee Extension, Hip Flexion/Extension",
    movementPattern: "Split Squat",
    equipment: ["Adjustable Bench", "Dumbbell", "Wedges"],
    premium: true,
    favorite: true,
  },
  {
    id: "bulgarian_smith_machine_split_squat",
    name: "Bulgarian Smith Machine Split Squat",
    category: "Quads",
    primaryMuscles: ["Quadriceps"],
    secondaryMuscles: ["Glutes", "Adductors", "Erectors/Abs"],
    romBias: "Lengthened",
    mainTrainingApplication: "Knee Extension, Hip Flexion/Extension",
    movementPattern: "Split Squat",
    equipment: ["Machine"],
    premium: true,
    favorite: true,
  },
  {
    id: "bulgarian_smith_machine_split_squat_heel_elevated",
    name: "Bulgarian Smith Machine Split Squat Heel Elevated (10-20 Degrees)",
    category: "Quads",
    primaryMuscles: ["Quadriceps"],
    secondaryMuscles: ["Glutes", "Adductors", "Erectors/Abs"],
    romBias: "Lengthened",
    mainTrainingApplication: "Knee Extension, Hip Flexion/Extension",
    movementPattern: "Split Squat",
    equipment: ["Machine", "Wedges"],
    premium: true,
    favorite: false,
  },
  {
    id: "leg_extension_machine_single_leg",
    name: "Leg Extension Machine Single-Leg",
    category: "Quads",
    primaryMuscles: ["Quadriceps"],
    secondaryMuscles: [],
    romBias: "Shortened",
    mainTrainingApplication: "Knee Extension",
    movementPattern: "Knee Extension",
    equipment: ["Leg Extension Station"],
    premium: true,
    favorite: false,
  },
  {
    id: "leg_extension_machine_single_leg_reclined",
    name: "Leg Extension Machine Single-Leg Reclined",
    category: "Quads",
    primaryMuscles: ["Quadriceps"],
    secondaryMuscles: ["Rectus Femoris"],
    romBias: "Shortened",
    mainTrainingApplication: "Knee Extension, Hip Extension",
    movementPattern: "Knee Extension",
    equipment: ["Leg Extension Station"],
    premium: true,
    favorite: true,
  },
  {
    id: "leg_extension_machine",
    name: "Leg Extension Machine",
    category: "Quads",
    primaryMuscles: ["Quadriceps"],
    secondaryMuscles: [],
    romBias: "Shortened",
    mainTrainingApplication: "Knee Extension",
    movementPattern: "Knee Extension",
    equipment: ["Leg Extension Station"],
    premium: false,
    favorite: false,
  },
  {
    id: "leg_extension_machine_reclined",
    name: "Leg Extension Machine Reclined",
    category: "Quads",
    primaryMuscles: ["Quadriceps"],
    secondaryMuscles: ["Rectus Femoris"],
    romBias: "Shortened",
    mainTrainingApplication: "Knee Extension, Hip Extension",
    movementPattern: "Knee Extension",
    equipment: ["Leg Extension Station"],
    premium: true,
    favorite: true,
  },
  {
    id: "leg_extension_band_single_leg",
    name: "Leg Extension Band Single-Leg",
    category: "Quads",
    primaryMuscles: ["Quadriceps"],
    secondaryMuscles: [],
    romBias: "Shortened",
    mainTrainingApplication: "Knee Extension",
    movementPattern: "Knee Extension",
    equipment: ["Band"],
    premium: true,
    favorite: false,
  },
  {
    id: "sissy_squat",
    name: "Sissy Squat",
    category: "Quads",
    primaryMuscles: ["Quadriceps"],
    secondaryMuscles: ["Rectus Femoris"],
    romBias: "Lengthened",
    mainTrainingApplication: "Knee Extension, Hip Extension",
    movementPattern: "Squat",
    equipment: ["Bodyweight"],
    premium: true,
    favorite: false,
  },
  {
    id: "sissy_squat_smith_machine",
    name: "Sissy Squat Smith Machine",
    category: "Quads",
    primaryMuscles: ["Quadriceps"],
    secondaryMuscles: ["Rectus Femoris", "Erectors/Abs"],
    romBias: "Lengthened",
    mainTrainingApplication: "Knee Extension, Hip Extension",
    movementPattern: "Squat",
    equipment: ["Smith Machine"],
    premium: true,
    favorite: false,
  },
  {
    id: "sissy_hack_squat",
    name: "Sissy Hack Squat",
    category: "Quads",
    primaryMuscles: ["Quadriceps"],
    secondaryMuscles: ["Rectus Femoris", "Erectors/Abs"],
    romBias: "Lengthened",
    mainTrainingApplication: "Knee Extension, Hip Extension",
    movementPattern: "Squat",
    equipment: ["Hack Squat Station"],
    premium: true,
    favorite: false,
  },
  {
    id: "reverse_nordic",
    name: "Reverse Nordic",
    category: "Quads",
    primaryMuscles: ["Quadriceps"],
    secondaryMuscles: ["Rectus Femoris", "Hip Flexors"],
    romBias: "Lengthened",
    mainTrainingApplication: "Knee Extension, Hip Extension",
    movementPattern: "Knee Extension",
    equipment: ["Bodyweight"],
    premium: true,
    favorite: false,
  },
  {
    id: "reverse_nordic_banded",
    name: "Reverse Nordic Banded",
    category: "Quads",
    primaryMuscles: ["Quadriceps"],
    secondaryMuscles: ["Rectus Femoris", "Hip Flexors"],
    romBias: "Lengthened",
    mainTrainingApplication: "Knee Extension, Hip Extension",
    movementPattern: "Knee Extension",
    equipment: ["Band"],
    premium: true,
    favorite: true,
  },
  {
    id: "somersault_squat_with_smith_machine",
    name: "Somersault Squat with Smith Machine",
    category: "Quads",
    primaryMuscles: ["Quadriceps"],
    secondaryMuscles: ["Glutes", "Erectors/Abs"],
    romBias: "Lengthened",
    mainTrainingApplication: "Knee Extension, Hip Flexion",
    movementPattern: "Squat",
    equipment: ["Smith Machine"],
    premium: true,
    favorite: false,
  },
  {
    id: "wall_sit",
    name: "Wall Sit",
    category: "Quads",
    primaryMuscles: ["Quadriceps"],
    secondaryMuscles: [],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Resisted Knee Extension",
    movementPattern: "-",
    equipment: ["Bodyweight"],
    premium: false,
    favorite: false,
  },
  {
    id: "wall_sit_heels_elevated",
    name: "Wall Sit Heels Elevated (10-20 Degrees)",
    category: "Quads",
    primaryMuscles: ["Quadriceps"],
    secondaryMuscles: [],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Resisted Knee Extension",
    movementPattern: "-",
    equipment: ["Bodyweight", "Wedges"],
    premium: true,
    favorite: false,
  },
  {
    id: "spanish_squat",
    name: "Spanish Squat",
    category: "Quads",
    primaryMuscles: ["Quadriceps"],
    secondaryMuscles: [],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Knee Extension, Hip Flexion/Extension",
    movementPattern: "Squat",
    equipment: ["Band"],
    premium: true,
    favorite: false,
  },
];
// ======================
// HAMSTRINGS
// ======================

const hamstringExercises = [
  {
    id: "dumbbell_stiff_legged_deadlift",
    name: "Dumbbell Stiff-Legged Deadlift",
    category: "Hamstrings",
    primaryMuscles: ["Hamstrings"],
    secondaryMuscles: ["Glutes", "Erectors"],
    romBias: "Lengthened",
    mainTrainingApplication: "Hip Extension, Knee Extension",
    movementPattern: "Hip Hinge",
    equipment: ["Dumbbell"],
    premium: true,
    favorite: false,
  },
  {
    id: "dumbbell_defecit_stiff_legged_deadlift",
    name: "Dumbbell Defecit Stiff-Legged Deadlift",
    category: "Hamstrings",
    primaryMuscles: ["Hamstrings"],
    secondaryMuscles: ["Glutes", "Erectors"],
    romBias: "Lengthened",
    mainTrainingApplication: "Hip Extension, Knee Extension",
    movementPattern: "Hip Hinge",
    equipment: ["Dumbbell"],
    premium: true,
    favorite: false,
  },
  {
    id: "dumbbell_rdl_hamstring_focused",
    name: "Dumbbell RDL Hamstring Focused",
    category: "Hamstrings",
    primaryMuscles: ["Hamstrings"],
    secondaryMuscles: ["Glutes", "Erectors"],
    romBias: "Lengthened",
    mainTrainingApplication: "Hip Extension, Knee Extension",
    movementPattern: "Hip Hinge",
    equipment: ["Dumbbell"],
    premium: false,
    favorite: false,
  },
  {
    id: "barbell_stiff_legged_deadlift",
    name: "Barbell Stiff-Legged Deadlift",
    category: "Hamstrings",
    primaryMuscles: ["Hamstrings"],
    secondaryMuscles: ["Glutes", "Erectors"],
    romBias: "Lengthened",
    mainTrainingApplication: "Hip Extension, Knee Extension",
    movementPattern: "Hip Hinge",
    equipment: ["Barbell"],
    premium: true,
    favorite: true,
  },
  {
    id: "barbell_defecit_stiff_legged_deadlift",
    name: "Barbell Defecit Stiff-Legged Deadlift",
    category: "Hamstrings",
    primaryMuscles: ["Hamstrings"],
    secondaryMuscles: ["Glutes", "Erectors"],
    romBias: "Lengthened",
    mainTrainingApplication: "Hip Extension, Knee Extension",
    movementPattern: "Hip Hinge",
    equipment: ["Barbell"],
    premium: true,
    favorite: false,
  },
  {
    id: "barbell_rdl_hamstring_focused",
    name: "Barbell RDL Hamstring Focused",
    category: "Hamstrings",
    primaryMuscles: ["Hamstrings"],
    secondaryMuscles: ["Glutes", "Erectors"],
    romBias: "Lengthened",
    mainTrainingApplication: "Hip Extension, Knee Extension",
    movementPattern: "Hip Hinge",
    equipment: ["Barbell"],
    premium: true,
    favorite: true,
  },
  {
    id: "trapbar_stiff_legged_deadlift",
    name: "Trap Bar Stiff-Legged Deadlift",
    category: "Hamstrings",
    primaryMuscles: ["Hamstrings"],
    secondaryMuscles: ["Glutes", "Erectors"],
    romBias: "Lengthened",
    mainTrainingApplication: "Hip Extension, Knee Extension",
    movementPattern: "Hip Hinge",
    equipment: ["Trap Bar"],
    premium: true,
    favorite: false,
  },
  {
    id: "trapbar_defecit_stiff_legged_deadlift",
    name: "Trap Bar Defecit Stiff-Legged Deadlift",
    category: "Hamstrings",
    primaryMuscles: ["Hamstrings"],
    secondaryMuscles: ["Glutes", "Erectors"],
    romBias: "Lengthened",
    mainTrainingApplication: "Hip Extension, Knee Extension",
    movementPattern: "Hip Hinge",
    equipment: ["Trap Bar"],
    premium: true,
    favorite: false,
  },
  {
    id: "trapbar_rdl_hamstring_focused",
    name: "Trap Bar RDL Hamstring Focused",
    category: "Hamstrings",
    primaryMuscles: ["Hamstrings"],
    secondaryMuscles: ["Glutes", "Erectors"],
    romBias: "Lengthened",
    mainTrainingApplication: "Hip Extension, Knee Extension",
    movementPattern: "Hip Hinge",
    equipment: ["Trap Bar"],
    premium: true,
    favorite: false,
  },
  {
    id: "machine_stiff_legged_deadlift",
    name: "Machine Stiff-Legged Deadlift",
    category: "Hamstrings",
    primaryMuscles: ["Hamstrings"],
    secondaryMuscles: ["Glutes", "Erectors"],
    romBias: "Lengthened",
    mainTrainingApplication: "Hip Extension, Knee Extension",
    movementPattern: "Hip Hinge",
    equipment: ["Machine"],
    premium: true,
    favorite: true,
  },
  {
    id: "machine_rdl_hamstring_focused",
    name: "Machine RDL Hamstring Focused",
    category: "Hamstrings",
    primaryMuscles: ["Hamstrings"],
    secondaryMuscles: ["Glutes", "Erectors"],
    romBias: "Lengthened",
    mainTrainingApplication: "Hip Extension, Knee Extension",
    movementPattern: "Hip Hinge",
    equipment: ["Machine"],
    premium: true,
    favorite: true,
  },
  {
    id: "split_stance_single_leg_db_deadlift_hamstring_focused",
    name: "Split-Stance Single-Leg DB Deadlift Hamstring Focused",
    category: "Hamstrings",
    primaryMuscles: ["Hamstrings"],
    secondaryMuscles: ["Glutes", "Erectors"],
    romBias: "Lengthened",
    mainTrainingApplication: "Hip Extension, Knee Extension",
    movementPattern: "Hip Hinge",
    equipment: ["Dumbbell"],
    premium: true,
    favorite: false,
  },
  {
    id: "split_stance_single_leg_cable_deadlift_hamstring_focused",
    name: "Split Stance Single-Leg Cable Deadlift Hamstring Focused",
    category: "Hamstrings",
    primaryMuscles: ["Hamstrings"],
    secondaryMuscles: ["Glutes", "Erectors"],
    romBias: "Lengthened",
    mainTrainingApplication: "Hip Extension, Knee Extension",
    movementPattern: "Hip Hinge",
    equipment: ["Cable"],
    premium: true,
    favorite: false,
  },
  {
    id: "hyperextension_45_degree_hamstring_focused",
    name: "45 Degree Hyper Extension Hamstring Focused",
    category: "Hamstrings",
    primaryMuscles: ["Hamstrings"],
    secondaryMuscles: ["Glute Max", "Erectors"],
    romBias: "Lengthened",
    mainTrainingApplication: "Hip Extension, Knee Extension",
    movementPattern: "Hip Hinge",
    equipment: ["45 Degree Hyper Extension Station"],
    premium: true,
    favorite: true,
  },
  {
    id: "hyperextension_45_degree_single_leg_hamstring_focused",
    name: "45 Degree Hyper Extension Single-Leg Hamstring Focused",
    category: "Hamstrings",
    primaryMuscles: ["Hamstrings"],
    secondaryMuscles: ["Glute Max", "Erectors"],
    romBias: "Lengthened",
    mainTrainingApplication: "Hip Extension, Knee Extension",
    movementPattern: "Hip Hinge",
    equipment: ["45 Degree Hyper Extension Station"],
    premium: true,
    favorite: true,
  },
  {
    id: "machine_lying_hamstring_curl",
    name: "Machine Lying Hamstring Curl",
    category: "Hamstrings",
    primaryMuscles: ["Hamstrings"],
    secondaryMuscles: [],
    romBias: "Shortened",
    mainTrainingApplication: "Knee Flexion, Hip Extension",
    movementPattern: "Knee Flexion",
    equipment: ["Lying Leg Curl Machine"],
    premium: true,
    favorite: true,
  },
  {
    id: "machine_lying_hamstring_curl_single_leg",
    name: "Machine Lying Hamstring Curl Single-Leg",
    category: "Hamstrings",
    primaryMuscles: ["Hamstrings"],
    secondaryMuscles: [],
    romBias: "Shortened",
    mainTrainingApplication: "Knee Flexion, Hip Extension",
    movementPattern: "Knee Flexion",
    equipment: ["Lying Leg Curl Machine"],
    premium: true,
    favorite: false,
  },
  {
    id: "cable_lying_hamstring_curl",
    name: "Cable Lying Hamstring Curl",
    category: "Hamstrings",
    primaryMuscles: ["Hamstrings"],
    secondaryMuscles: [],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Knee Flexion, Hip Extension",
    movementPattern: "Knee Flexion",
    equipment: ["Cable", "Ankle Cuffs"],
    premium: true,
    favorite: false,
  },
  {
    id: "cable_lying_hamstring_curl_single_leg",
    name: "Cable Lying Hamstring Curl Single-Leg",
    category: "Hamstrings",
    primaryMuscles: ["Hamstrings"],
    secondaryMuscles: [],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Knee Flexion, Hip Extension",
    movementPattern: "Knee Flexion",
    equipment: ["Cable", "Ankle Cuffs"],
    premium: true,
    favorite: false,
  },
  {
    id: "band_lying_hamstring_curl",
    name: "Band Lying Hamstring Curl",
    category: "Hamstrings",
    primaryMuscles: ["Hamstrings"],
    secondaryMuscles: [],
    romBias: "Shortened",
    mainTrainingApplication: "Knee Flexion, Hip Extension",
    movementPattern: "Knee Flexion",
    equipment: ["Band"],
    premium: true,
    favorite: false,
  },
  {
    id: "band_lying_hamstring_curl_single_leg",
    name: "Band Lying Hamstring Curl Single-Leg",
    category: "Hamstrings",
    primaryMuscles: ["Hamstrings"],
    secondaryMuscles: [],
    romBias: "Shortened",
    mainTrainingApplication: "Knee Flexion, Hip Extension",
    movementPattern: "Knee Flexion",
    equipment: ["Band"],
    premium: false,
    favorite: false,
  },
  {
    id: "machine_seated_hamstring_curl",
    name: "Machine Seated Hamstring Curl",
    category: "Hamstrings",
    primaryMuscles: ["Hamstrings"],
    secondaryMuscles: [],
    romBias: "Shortened",
    mainTrainingApplication: "Knee Flexion, Hip Flexion",
    movementPattern: "Knee Flexion",
    equipment: ["Seated Leg Curl Machine Station"],
    premium: true,
    favorite: true,
  },
  {
    id: "machine_seated_hamstring_curl_single_leg",
    name: "Machine Seated Hamstring Curl Single-Leg",
    category: "Hamstrings",
    primaryMuscles: ["Hamstrings"],
    secondaryMuscles: [],
    romBias: "Shortened",
    mainTrainingApplication: "Knee Flexion, Hip Flexion",
    movementPattern: "Knee Flexion",
    equipment: ["Seated Leg Curl Machine Station"],
    premium: true,
    favorite: false,
  },
  {
    id: "cable_seated_hamstring_curl_single_leg",
    name: "Cable Seated Hamstring Curl Single-Leg",
    category: "Hamstrings",
    primaryMuscles: ["Hamstrings"],
    secondaryMuscles: [],
    romBias: "Shortened",
    mainTrainingApplication: "Knee Flexion, Hip Flexion",
    movementPattern: "Knee Flexion",
    equipment: ["Cable", "Ankle Cuffs"],
    premium: true,
    favorite: false,
  },
  {
    id: "band_seated_hamstring_curl_single_leg",
    name: "Band Seated Hamstring Curl Single-Leg",
    category: "Hamstrings",
    primaryMuscles: ["Hamstrings"],
    secondaryMuscles: [],
    romBias: "Shortened",
    mainTrainingApplication: "Knee Flexion, Hip Flexion",
    movementPattern: "Knee Flexion",
    equipment: ["Band"],
    premium: true,
    favorite: false,
  },
  {
    id: "machine_standing_hamstring_curl_single_leg",
    name: "Machine Standing Hamstring Curl Single-Leg",
    category: "Hamstrings",
    primaryMuscles: ["Hamstrings"],
    secondaryMuscles: [],
    romBias: "Shortened",
    mainTrainingApplication: "Knee Flexion",
    movementPattern: "Knee Flexion",
    equipment: ["Standing Leg Curl Machine Station"],
    premium: true,
    favorite: false,
  },
  {
    id: "cable_standing_hamstring_curl_single_leg",
    name: "Cable Standing Hamstring Curl Single-Leg",
    category: "Hamstrings",
    primaryMuscles: ["Hamstrings"],
    secondaryMuscles: [],
    romBias: "Shortened",
    mainTrainingApplication: "Knee Flexion",
    movementPattern: "Knee Flexion",
    equipment: ["Cable", "Ankle Cuffs"],
    premium: true,
    favorite: false,
  },
  {
    id: "band_standing_hamstring_curl_single_leg",
    name: "Band Standing Hamstring Curl Single-Leg",
    category: "Hamstrings",
    primaryMuscles: ["Hamstrings"],
    secondaryMuscles: [],
    romBias: "Shortened",
    mainTrainingApplication: "Knee Flexion",
    movementPattern: "Knee Flexion",
    equipment: ["Band"],
    premium: true,
    favorite: false,
  },
  {
    id: "supine_hamstring_curl",
    name: "Supine Hamstring Curl",
    category: "Hamstrings",
    primaryMuscles: ["Hamstrings"],
    secondaryMuscles: [],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Knee Flexion, Hip Extension",
    movementPattern: "Knee Flexion",
    equipment: ["Bodyweight"],
    premium: false,
    favorite: false,
  },
  {
    id: "supine_hamstring_curl_single_leg",
    name: "Supine Hamstring Curl Single-Leg",
    category: "Hamstrings",
    primaryMuscles: ["Hamstrings"],
    secondaryMuscles: [],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Knee Flexion, Hip Extension",
    movementPattern: "Knee Flexion",
    equipment: ["Bodyweight"],
    premium: true,
    favorite: true,
  },
  {
    id: "supine_hamstring_curl_with_exercise_ball",
    name: "Supine Hamstring Curl with Exercise Ball",
    category: "Hamstrings",
    primaryMuscles: ["Hamstrings"],
    secondaryMuscles: [],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Knee Flexion, Hip Extension",
    movementPattern: "Knee Flexion",
    equipment: ["Bodyweight", "Exercise Ball"],
    premium: true,
    favorite: false,
  },
  {
    id: "supine_hamstring_curl_single_leg_with_exercise_ball",
    name: "Supine Hamstring Curl Single-Leg with Exercise Ball",
    category: "Hamstrings",
    primaryMuscles: ["Hamstrings"],
    secondaryMuscles: [],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Knee Flexion, Hip Extension",
    movementPattern: "Knee Flexion",
    equipment: ["Bodyweight", "Exercise Ball"],
    premium: true,
    favorite: false,
  },
  {
    id: "nordic_curl",
    name: "Nordic Curl",
    category: "Hamstrings",
    primaryMuscles: ["Hamstrings"],
    secondaryMuscles: ["Abs"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Knee Flexion, Resisted Hip Extension",
    movementPattern: "Knee Flexion",
    equipment: ["Bodyweight"],
    premium: true,
    favorite: false,
  },
  {
    id: "nordic_curl_banded",
    name: "Nordic Curl Banded",
    category: "Hamstrings",
    primaryMuscles: ["Hamstrings"],
    secondaryMuscles: ["Abs"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Knee Flexion, Resisted Hip Extension",
    movementPattern: "Knee Flexion",
    equipment: ["Bodyweight", "Band"],
    premium: true,
    favorite: false,
  },
  {
    id: "glute_ham_raise_extension",
    name: "Glute Ham Raise Extension",
    category: "Hamstrings",
    primaryMuscles: ["Hamstrings"],
    secondaryMuscles: ["Erectors/Abs"],
    romBias: "Lengthened",
    mainTrainingApplication: "Hip Extension/Flexion, Knee Flexion/Extension",
    movementPattern: "Hip Hinge / Knee Flexion",
    equipment: ["Glute Ham Developer Station (GHD)"],
    premium: true,
    favorite: false,
  },
];
// ======================
// GLUTE MAX
// ======================

const gluteExercises = [
  {
    id: "hyperextension_45_degree_double_leg_glute_focused",
    name: "45 Degree Hyper Extension Double-Legged Glute Focused",
    category: "Glutes",
    primaryMuscles: ["Glute Max"],
    secondaryMuscles: ["Glute Med/Min", "Hamstrings", "Erectors"],
    romBias: "Shortened",
    mainTrainingApplication: "Hip Extension, Knee Extension",
    movementPattern: "Hip Hinge",
    equipment: ["45 Degree Hyper Extension Station"],
    premium: true,
    favorite: true,
  },
  {
    id: "hyperextension_45_degree_single_leg_glute_focused",
    name: "45 Degree Hyper Extension Single-Legged Glute Focused",
    category: "Glutes",
    primaryMuscles: ["Glute Max"],
    secondaryMuscles: ["Glute Med/Min", "Hamstrings", "Erectors"],
    romBias: "Shortened",
    mainTrainingApplication: "Hip Extension, Knee Extension",
    movementPattern: "Hip Hinge",
    equipment: ["45 Degree Hyper Extension Station"],
    premium: true,
    favorite: true,
  },
  {
    id: "barbell_rdl_glute_focused",
    name: "Barbell RDL Glute Focused",
    category: "Glutes",
    primaryMuscles: ["Glute Max"],
    secondaryMuscles: ["Glute Med/Min", "Hamstrings", "Erectors"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Hip Flexion/Extension, Knee Flexion/Extension",
    movementPattern: "Hip Hinge",
    equipment: ["Barbell"],
    premium: true,
    favorite: true,
  },
  {
    id: "trapbar_rdl_glute_focused",
    name: "Trap Bar RDL Glute Focused",
    category: "Glutes",
    primaryMuscles: ["Glute Max"],
    secondaryMuscles: ["Glute Med/Min", "Hamstrings", "Erectors"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Hip Flexion/Extension, Knee Flexion/Extension",
    movementPattern: "Hip Hinge",
    equipment: ["Trap Bar"],
    premium: true,
    favorite: false,
  },
  {
    id: "machine_rdl_glute_focused",
    name: "Machine RDL Glute Focused",
    category: "Glutes",
    primaryMuscles: ["Glute Max"],
    secondaryMuscles: ["Glute Med/Min", "Hamstrings", "Erectors"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Hip Flexion/Extension, Knee Flexion/Extension",
    movementPattern: "Hip Hinge",
    equipment: ["Machine"],
    premium: true,
    favorite: true,
  },
  {
    id: "smith_machine_rdl_glute_focused",
    name: "Smith Machine RDL Glute Focused",
    category: "Glutes",
    primaryMuscles: ["Glute Max"],
    secondaryMuscles: ["Glute Med/Min", "Hamstrings", "Erectors"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Hip Flexion/Extension, Knee Flexion/Extension",
    movementPattern: "Hip Hinge",
    equipment: ["Smith Machine"],
    premium: true,
    favorite: false,
  },
  {
    id: "dumbbell_rdl_glute_focused",
    name: "Dumbbell RDL Glute Focused",
    category: "Glutes",
    primaryMuscles: ["Glute Max"],
    secondaryMuscles: ["Glute Med/Min", "Hamstrings", "Erectors"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Hip Flexion/Extension, Knee Flexion/Extension",
    movementPattern: "Hip Hinge",
    equipment: ["Dumbbell"],
    premium: false,
    favorite: false,
  },
  {
    id: "split_stance_single_leg_db_deadlift_glute_focused",
    name: "Split-Stance Single-Leg DB Deadlift Glute Focused",
    category: "Glutes",
    primaryMuscles: ["Glute Max"],
    secondaryMuscles: ["Glute Med/Min", "Hamstrings", "Erectors"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Hip Flexion/Extension, Knee Flexion/Extension",
    movementPattern: "Hip Hinge",
    equipment: ["Dumbbell"],
    premium: true,
    favorite: false,
  },
  {
    id: "split_stance_single_leg_cable_deadlift_glute_focused",
    name: "Split Stance Single-Leg Cable Deadlift Glute Focused",
    category: "Glutes",
    primaryMuscles: ["Glute Max"],
    secondaryMuscles: ["Glute Med/Min", "Hamstrings", "Erectors"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Hip Flexion/Extension, Knee Flexion/Extension",
    movementPattern: "Hip Hinge",
    equipment: ["Cable"],
    premium: true,
    favorite: false,
  },
  {
    id: "split_stance_single_leg_trapbar_deadlift_glute_focused",
    name: "Split Stance Single-Leg Trap Bar Deadlift Glute Focused",
    category: "Glutes",
    primaryMuscles: ["Glute Max"],
    secondaryMuscles: ["Glute Med/Min", "Hamstrings", "Erectors"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Hip Flexion/Extension, Knee Flexion/Extension",
    movementPattern: "Hip Hinge",
    equipment: ["Trap Bar"],
    premium: true,
    favorite: false,
  },
  {
    id: "reverse_lunge_with_dumbbells",
    name: "Reverse Lunge with Dumbbells",
    category: "Glutes",
    primaryMuscles: ["Glute Max"],
    secondaryMuscles: ["Glute Med/Min"],
    romBias: "Lengthened",
    mainTrainingApplication: "Hip Flexion/Extension, Knee Flexion/Extension",
    movementPattern: "Lunge",
    equipment: ["Dumbbell"],
    premium: false,
    favorite: false,
  },
  {
    id: "reverse_lunge_with_barbell",
    name: "Reverse Lunge with Barbell",
    category: "Glutes",
    primaryMuscles: ["Glute Max"],
    secondaryMuscles: ["Glute Med/Min"],
    romBias: "Lengthened",
    mainTrainingApplication: "Hip Flexion/Extension, Knee Flexion/Extension",
    movementPattern: "Lunge",
    equipment: ["Barbell"],
    premium: true,
    favorite: false,
  },
  {
    id: "bulgarian_db_split_squat_feet_wider",
    name: "Bulgarian DB Split Squat Feet Wider",
    category: "Glutes",
    primaryMuscles: ["Glute Max"],
    secondaryMuscles: ["Glute Med/Min"],
    romBias: "Lengthened",
    mainTrainingApplication: "Hip Flexion/Extension, Knee Flexion/Extension",
    movementPattern: "Split Squat",
    equipment: ["Dumbbell"],
    premium: true,
    favorite: false,
  },
  {
    id: "bulgarian_smith_machine_split_squat_feet_wider",
    name: "Bulgarian Smith Machine Split Squat Feet Wider",
    category: "Glutes",
    primaryMuscles: ["Glute Max"],
    secondaryMuscles: ["Glute Med/Min", "Erectors"],
    romBias: "Lengthened",
    mainTrainingApplication: "Hip Flexion/Extension, Knee Flexion/Extension",
    movementPattern: "Split Squat",
    equipment: ["Smith Machine"],
    premium: true,
    favorite: true,
  },
  {
    id: "bulgarian_safey_bar_hatfield_split_squat_feet_wider",
    name: "Bulgarian Safey Bar Hatfield Split Squat Feet Wider",
    category: "Glutes",
    primaryMuscles: ["Glute Max"],
    secondaryMuscles: ["Glute Med/Min", "Erectors"],
    romBias: "Lengthened",
    mainTrainingApplication: "Hip Flexion/Extension, Knee Flexion/Extension",
    movementPattern: "Split Squat",
    equipment: ["Safety Bar", "Squat Rack Station"],
    premium: true,
    favorite: false,
  },
  {
    id: "step_up_with_dumbbell",
    name: "Step-Up with Dumbbell",
    category: "Glutes",
    primaryMuscles: ["Glute Max"],
    secondaryMuscles: ["Glute Med/Min", "Quads"],
    romBias: "Lengthened",
    mainTrainingApplication: "Hip Flexion/Extension, Knee Flexion/Extension",
    movementPattern: "Step-Up",
    equipment: ["Adjustable Bench", "Dumbbell"],
    premium: true,
    favorite: true,
  },
  {
    id: "step_up_with_cable",
    name: "Step-Up with Cable",
    category: "Glutes",
    primaryMuscles: ["Glute Max"],
    secondaryMuscles: ["Glute Med/Min", "Quads"],
    romBias: "Lengthened",
    mainTrainingApplication: "Hip Flexion/Extension, Knee Flexion/Extension",
    movementPattern: "Step-Up",
    equipment: ["Adjustable Bench", "Cable"],
    premium: true,
    favorite: false,
  },
  {
    id: "lateral_step_up_with_dumbbell",
    name: "Lateral Step-Up with Dumbbell",
    category: "Glutes",
    primaryMuscles: ["Glute Max"],
    secondaryMuscles: ["Glute Med/Min", "Quads"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication:
      "Hip Flexion/Extension, Knee Flexion/Extension, Hip Abduction",
    movementPattern: "Step-Up",
    equipment: ["Adjustable Bench", "Dumbbell"],
    premium: true,
    favorite: false,
  },
  {
    id: "lateral_step_up_with_cable_glutes",
    name: "Lateral Step-Up with Cable",
    category: "Glutes",
    primaryMuscles: ["Glute Max"],
    secondaryMuscles: ["Glute Med/Min", "Quads"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication:
      "Hip Flexion/Extension, Knee Flexion/Extension, Hip Abduction",
    movementPattern: "Step-Up",
    equipment: ["Adjustable Bench", "Cable"],
    premium: true,
    favorite: false,
  },
  {
    id: "barbell_hip_thrust",
    name: "Barbell Hip Thrust",
    category: "Glutes",
    primaryMuscles: ["Glute Max"],
    secondaryMuscles: ["Glute Med/Min", "Erectors"],
    romBias: "Shortened",
    mainTrainingApplication: "Hip Flexion/Extension, Knee Flexion",
    movementPattern: "Hip Thrust",
    equipment: ["Adjustable Bench", "Barbell"],
    premium: true,
    favorite: false,
  },
  {
    id: "smith_machine_hip_thrust",
    name: "Smith Machine Hip Thrust",
    category: "Glutes",
    primaryMuscles: ["Glute Max"],
    secondaryMuscles: ["Glute Med/Min", "Erectors"],
    romBias: "Shortened",
    mainTrainingApplication: "Hip Flexion/Extension, Knee Flexion",
    movementPattern: "Hip Thrust",
    equipment: ["Adjustable Bench", "Smith Machine"],
    premium: true,
    favorite: true,
  },
  {
    id: "smith_machine_b_stance_hip_thrust",
    name: "Smith Machine B-Stance Hip Thrust",
    category: "Glutes",
    primaryMuscles: ["Glute Max"],
    secondaryMuscles: ["Glute Med/Min", "Erectors"],
    romBias: "Shortened",
    mainTrainingApplication: "Hip Flexion/Extension, Knee Flexion",
    movementPattern: "Hip Thrust",
    equipment: ["Adjustable Bench", "Smith Machine"],
    premium: true,
    favorite: true,
  },
  {
    id: "smith_machine_single_leg_hip_thrust",
    name: "Smith Machine Single-Leg Hip Thrust",
    category: "Glutes",
    primaryMuscles: ["Glute Max"],
    secondaryMuscles: ["Glute Med/Min", "Erectors"],
    romBias: "Shortened",
    mainTrainingApplication: "Hip Flexion/Extension, Knee Flexion",
    movementPattern: "Hip Thrust",
    equipment: ["Adjustable Bench", "Smith Machine"],
    premium: true,
    favorite: false,
  },
  {
    id: "dumbbell_hip_thrust",
    name: "Dumbbell Hip Thrust",
    category: "Glutes",
    primaryMuscles: ["Glute Max"],
    secondaryMuscles: ["Glute Med/Min", "Erectors"],
    romBias: "Shortened",
    mainTrainingApplication: "Hip Flexion/Extension, Knee Flexion",
    movementPattern: "Hip Thrust",
    equipment: ["Adjustable Bench", "Dumbbell"],
    premium: false,
    favorite: false,
  },
  {
    id: "dumbbell_b_stance_hip_thrust",
    name: "Dumbbell B-Stance Hip Thrust",
    category: "Glutes",
    primaryMuscles: ["Glute Max"],
    secondaryMuscles: ["Glute Med/Min", "Erectors"],
    romBias: "Shortened",
    mainTrainingApplication: "Hip Flexion/Extension, Knee Flexion",
    movementPattern: "Hip Thrust",
    equipment: ["Adjustable Bench", "Dumbbell"],
    premium: true,
    favorite: false,
  },
  {
    id: "dumbbell_single_leg_hip_thrust",
    name: "Dumbbell Single-Leg Hip Thrust",
    category: "Glutes",
    primaryMuscles: ["Glute Max"],
    secondaryMuscles: ["Glute Med/Min", "Erectors"],
    romBias: "Shortened",
    mainTrainingApplication: "Hip Flexion/Extension, Knee Flexion",
    movementPattern: "Hip Thrust",
    equipment: ["Adjustable Bench", "Dumbbell"],
    premium: true,
    favorite: false,
  },
  {
    id: "band_hip_thrust",
    name: "Band Hip Thrust",
    category: "Glutes",
    primaryMuscles: ["Glute Max"],
    secondaryMuscles: ["Glute Med/Min", "Erectors"],
    romBias: "Shortened",
    mainTrainingApplication: "Hip Flexion/Extension, Knee Flexion",
    movementPattern: "Hip Thrust",
    equipment: ["Adjustable Bench", "Band"],
    premium: true,
    favorite: false,
  },
  {
    id: "band_b_stance_hip_thrust",
    name: "Band B-Stance Hip Thrust",
    category: "Glutes",
    primaryMuscles: ["Glute Max"],
    secondaryMuscles: ["Glute Med/Min", "Erectors"],
    romBias: "Shortened",
    mainTrainingApplication: "Hip Flexion/Extension, Knee Flexion",
    movementPattern: "Hip Thrust",
    equipment: ["Adjustable Bench", "Band"],
    premium: true,
    favorite: false,
  },
  {
    id: "band_single_leg_hip_thrust",
    name: "Band Single-Leg Hip Thrust",
    category: "Glutes",
    primaryMuscles: ["Glute Max"],
    secondaryMuscles: ["Glute Med/Min", "Erectors"],
    romBias: "Shortened",
    mainTrainingApplication: "Hip Flexion/Extension, Knee Flexion",
    movementPattern: "Hip Thrust",
    equipment: ["Adjustable Bench", "Band"],
    premium: true,
    favorite: false,
  },
  {
    id: "machine_hip_thrust",
    name: "Machine Hip Thrust",
    category: "Glutes",
    primaryMuscles: ["Glute Max"],
    secondaryMuscles: ["Glute Med/Min", "Erectors"],
    romBias: "Shortened",
    mainTrainingApplication: "Hip Flexion/Extension, Knee Flexion",
    movementPattern: "Hip Thrust",
    equipment: ["Hip Thrust Machine Station"],
    premium: true,
    favorite: true,
  },
  {
    id: "machine_b_stance_hip_thrust",
    name: "Machine B-stance Hip Thrust",
    category: "Glutes",
    primaryMuscles: ["Glute Max"],
    secondaryMuscles: ["Glute Med/Min", "Erectors"],
    romBias: "Shortened",
    mainTrainingApplication: "Hip Flexion/Extension, Knee Flexion",
    movementPattern: "Hip Thrust",
    equipment: ["Hip Thrust Machine Station"],
    premium: true,
    favorite: true,
  },
  {
    id: "machine_single_leg_hip_thrust",
    name: "Machine Single-Leg Hip Thrust",
    category: "Glutes",
    primaryMuscles: ["Glute Max"],
    secondaryMuscles: ["Glute Med/Min", "Erectors"],
    romBias: "Shortened",
    mainTrainingApplication: "Hip Flexion/Extension, Knee Flexion",
    movementPattern: "Hip Thrust",
    equipment: ["Hip Thrust Machine Station"],
    premium: true,
    favorite: true,
  },
  {
    id: "kas_hip_thrust",
    name: "Kas Hip Thrust",
    category: "Glutes",
    primaryMuscles: ["Glute Max"],
    secondaryMuscles: ["Glute Med/Min", "Erectors"],
    romBias: "Shortened",
    mainTrainingApplication: "Hip Flexion/Extension, Knee Flexion",
    movementPattern: "Hip Thrust",
    equipment: ["Smith Machine"],
    premium: true,
    favorite: true,
  },
  {
    id: "dumbbell_glute_bridge",
    name: "Dumbbell Glute Bridge",
    category: "Glutes",
    primaryMuscles: ["Glute Max"],
    secondaryMuscles: ["Glute Med/Min", "Erectors"],
    romBias: "Shortened",
    mainTrainingApplication: "Hip Extension, Knee Flexion",
    movementPattern: "Glute Bridge",
    equipment: ["Dumbbell"],
    premium: false,
    favorite: false,
  },
  {
    id: "dumbbell_b_stance_glute_bridge",
    name: "Dumbbell B-Stance Glute Bridge",
    category: "Glutes",
    primaryMuscles: ["Glute Max"],
    secondaryMuscles: ["Glute Med/Min", "Erectors"],
    romBias: "Shortened",
    mainTrainingApplication: "Hip Extension, Knee Flexion",
    movementPattern: "Glute Bridge",
    equipment: ["Dumbbell"],
    premium: true,
    favorite: false,
  },
  {
    id: "dumbbell_single_leg_glute_bridge",
    name: "Dumbbell Single-Leg Glute Bridge",
    category: "Glutes",
    primaryMuscles: ["Glute Max"],
    secondaryMuscles: ["Glute Med/Min", "Erectors"],
    romBias: "Shortened",
    mainTrainingApplication: "Hip Extension, Knee Flexion",
    movementPattern: "Glute Bridge",
    equipment: ["Dumbbell"],
    premium: true,
    favorite: false,
  },
  {
    id: "barbell_glute_bridge",
    name: "Barbell Glute Bridge",
    category: "Glutes",
    primaryMuscles: ["Glute Max"],
    secondaryMuscles: ["Glute Med/Min", "Erectors"],
    romBias: "Shortened",
    mainTrainingApplication: "Hip Extension, Knee Flexion",
    movementPattern: "Glute Bridge",
    equipment: ["Barbell"],
    premium: true,
    favorite: false,
  },
  {
    id: "barbell_b_stance_glute_bridge",
    name: "Barbell B-Stance Glute Bridge",
    category: "Glutes",
    primaryMuscles: ["Glute Max"],
    secondaryMuscles: ["Glute Med/Min", "Erectors"],
    romBias: "Shortened",
    mainTrainingApplication: "Hip Extension, Knee Flexion",
    movementPattern: "Glute Bridge",
    equipment: ["Barbell"],
    premium: true,
    favorite: false,
  },
  {
    id: "multi_hip_machine_hip_extension",
    name: "Multi-Hip Machine Hip Extension",
    category: "Glutes",
    primaryMuscles: ["Glute Max"],
    secondaryMuscles: ["Glute Med/Min"],
    romBias: "Lengthened",
    mainTrainingApplication: "Hip Flexion/Extension, Knee Flexion",
    movementPattern: "Hip Extension",
    equipment: ["Multi-Hip Machine Station"],
    premium: true,
    favorite: true,
  },
  {
    id: "glute_kickback_machine",
    name: "Glute Kickback Machine",
    category: "Glutes",
    primaryMuscles: ["Glute Max"],
    secondaryMuscles: ["Glute Med/Min", "Hamstrings"],
    romBias: "Shortened",
    mainTrainingApplication: "Hip Flexion/Extension, Knee Flexion/Extension",
    movementPattern: "Kickback",
    equipment: ["Glute Kickback Machine Station"],
    premium: true,
    favorite: false,
  },
  {
    id: "upper_glute_max_cable_kickback",
    name: "Upper Glute Max Cable Kickback",
    category: "Glutes",
    primaryMuscles: ["Glute Max"],
    secondaryMuscles: ["Glute Med/Min", "Hamstrings"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Hip Flexion/Extension, Knee Flexion/Extension",
    movementPattern: "Kickback",
    equipment: ["Cable"],
    premium: true,
    favorite: true,
  },
  {
    id: "donkey_kickback",
    name: "Donkey Kickback",
    category: "Glutes",
    primaryMuscles: ["Glute Max"],
    secondaryMuscles: ["Glute Med/Min", "Hamstrings"],
    romBias: "Shortened",
    mainTrainingApplication: "Hip Flexion/Extension, Knee Flexion",
    movementPattern: "Kickback",
    equipment: ["Adjustable Bench"],
    premium: true,
    favorite: false,
  },
  {
    id: "iliac_glute_drop_lunge",
    name: "Iliac-Glute Drop Lunge",
    category: "Glutes",
    primaryMuscles: ["Glute Max"],
    secondaryMuscles: ["Glute Med/Min"],
    romBias: "Lengthened",
    mainTrainingApplication: "Hip Flexion/Extension, Knee Flexion/Extension",
    movementPattern: "Lunge",
    equipment: ["Box/Step", "Dumbbell"],
    premium: true,
    favorite: true,
  },
  {
    id: "leg_press_feet_high_narrow",
    name: "Leg Press Feet High-Narrow",
    category: "Glutes",
    primaryMuscles: ["Glute Max"],
    secondaryMuscles: ["Glute Med/Min", "Adductor Magnus"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Hip Flexion/Extension, Knee Flexion/Extension",
    movementPattern: "Leg Press",
    equipment: ["Leg Press Station"],
    premium: true,
    favorite: true,
  },
  {
    id: "single_leg_leg_press_feet_high",
    name: "Single-Leg Leg Press Feet High",
    category: "Glutes",
    primaryMuscles: ["Glute Max"],
    secondaryMuscles: ["Glute Med/Min", "Adductor Magnus"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Hip Flexion/Extension, Knee Flexion/Extension",
    movementPattern: "Leg Press",
    equipment: ["Leg Press Station"],
    premium: true,
    favorite: true,
  },
];
// ======================
// GLUTE MED/MIN
// ======================

const gluteMedExercises = [
  {
    id: "multi_hip_machine_hip_abduction",
    name: "Multi-Hip Machine Hip Abduction",
    category: "Glutes",
    primaryMuscles: ["Glute Med/Min"],
    secondaryMuscles: ["Glute Max"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Hip Abduction/Adduction",
    movementPattern: "Hip Abduction",
    equipment: ["Multi-Hip Machine Station"],
    premium: true,
    favorite: false,
  },
  {
    id: "seated_hip_abductor_machine",
    name: "Seated Hip Abductor Machine",
    category: "Glutes",
    primaryMuscles: ["Glute Med/Min"],
    secondaryMuscles: ["Glute Max"],
    romBias: "Shortened",
    mainTrainingApplication: "Hip Abduction, Hip Flexion",
    movementPattern: "Hip Abduction",
    equipment: ["Hip Abductor Machine Station"],
    premium: true,
    favorite: true,
  },
  {
    id: "standing_hip_abduction_with_band",
    name: "Standing Hip Abduction with Band",
    category: "Glutes",
    primaryMuscles: ["Glute Med/Min"],
    secondaryMuscles: ["Glute Max"],
    romBias: "Shortened",
    mainTrainingApplication: "Hip Abduction",
    movementPattern: "Hip Abduction",
    equipment: ["Band"],
    premium: false,
    favorite: false,
  },
  {
    id: "seated_hip_abduction_with_band",
    name: "Seated Hip Abduction with Band",
    category: "Glutes",
    primaryMuscles: ["Glute Med/Min"],
    secondaryMuscles: ["Glute Max"],
    romBias: "Shortened",
    mainTrainingApplication: "Hip Abduction, Hip Flexion",
    movementPattern: "Hip Abduction",
    equipment: ["Band"],
    premium: true,
    favorite: false,
  },
  {
    id: "supine_hip_abduction_with_band",
    name: "Supine Hip Abduction with Band",
    category: "Glutes",
    primaryMuscles: ["Glute Med/Min"],
    secondaryMuscles: ["Glute Max"],
    romBias: "Shortened",
    mainTrainingApplication: "Hip Abduction, Hip Flexion",
    movementPattern: "Hip Abduction",
    equipment: ["Band"],
    premium: true,
    favorite: false,
  },
  {
    id: "side_lying_hip_abduction_with_band",
    name: "Side-lying Hip Abduction with Band",
    category: "Glutes",
    primaryMuscles: ["Glute Med/Min"],
    secondaryMuscles: ["Glute Max"],
    romBias: "Shortened",
    mainTrainingApplication: "Hip Abduction, Hip Extension",
    movementPattern: "Hip Abduction",
    equipment: ["Band"],
    premium: true,
    favorite: true,
  },
  {
    id: "side_lying_clamshell_with_band",
    name: "Side-lying ClamShell with Band",
    category: "Glutes",
    primaryMuscles: ["Glute Med/Min"],
    secondaryMuscles: ["Glute Max"],
    romBias: "Shortened",
    mainTrainingApplication: "Hip Abduction, Hip Flexion",
    movementPattern: "Hip Abduction",
    equipment: ["Band"],
    premium: true,
    favorite: false,
  },
  {
    id: "side_lying_plank_with_hip_dip_abductor_bias",
    name: "Side-lying Plank with Hip Dip Abductor Bias",
    category: "Glutes",
    primaryMuscles: ["Glute Med/Min"],
    secondaryMuscles: ["Glute Max"],
    romBias: "Lengthened",
    mainTrainingApplication: "Hip Abduction",
    movementPattern: "Hip Abduction",
    equipment: ["Adjustable Bench"],
    premium: true,
    favorite: true,
  },
  {
    id: "glute_med_cable_kickback",
    name: "Glute Med Cable Kickback",
    category: "Glutes",
    primaryMuscles: ["Glute Med/Min"],
    secondaryMuscles: ["Glute Max"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Hip Abduction/Adduction, Hip Extension",
    movementPattern: "Hip Abduction",
    equipment: ["Cable"],
    premium: true,
    favorite: true,
  },
  {
    id: "captain_morgan",
    name: "Captain Morgan",
    category: "Glutes",
    primaryMuscles: ["Glute Med/Min"],
    secondaryMuscles: ["Glute Max", "Quads"],
    romBias: "-",
    mainTrainingApplication: "Hip Abduction, Hip Flexion",
    movementPattern: "Hip Abduction",
    equipment: ["Bodyweight", "Wall"],
    premium: false,
    favorite: false,
  },
  {
    id: "lateral_walks_with_band",
    name: "Lateral Walks with Band",
    category: "Glutes",
    primaryMuscles: ["Glute Med/Min"],
    secondaryMuscles: ["Glute Max"],
    romBias: "-",
    mainTrainingApplication: "Hip Abduction",
    movementPattern: "Hip Abduction",
    equipment: ["Band"],
    premium: true,
    favorite: false,
  },
  {
    id: "monster_walks_with_band",
    name: "Monster Walks with Band",
    category: "Glutes",
    primaryMuscles: ["Glute Med/Min"],
    secondaryMuscles: ["Glute Max", "Quads"],
    romBias: "-",
    mainTrainingApplication: "Hip Abduction, Flexion",
    movementPattern: "Hip Abduction",
    equipment: ["Band"],
    premium: true,
    favorite: false,
  },
  {
    id: "backward_monster_walks_with_band",
    name: "Backward Monster Walks with Band",
    category: "Glutes",
    primaryMuscles: ["Glute Med/Min"],
    secondaryMuscles: ["Glute Max", "Quads"],
    romBias: "-",
    mainTrainingApplication: "Hip Abduction, Extension",
    movementPattern: "Hip Abduction",
    equipment: ["Band"],
    premium: true,
    favorite: false,
  },
  {
    id: "standing_clamshell_with_band",
    name: "Standing Clamshell with Band",
    category: "Glutes",
    primaryMuscles: ["Glute Med/Min"],
    secondaryMuscles: ["Glute Max"],
    romBias: "Shortened",
    mainTrainingApplication: "Hip Abduction",
    movementPattern: "Hip Abduction",
    equipment: ["Band"],
    premium: true,
    favorite: false,
  },
];
// ======================
// ADDUCTORS / HIP FLEXORS
// ======================

const adductorHipFlexorExercises = [
  {
    id: "multi_hip_machine_hip_adduction",
    name: "Multi-Hip Machine Hip Adduction",
    category: "Adductors/Hip Flexors",
    primaryMuscles: ["Adductors"],
    secondaryMuscles: [],
    romBias: "Shortened",
    mainTrainingApplication: "Hip Adduction/Abduction, Hip Flexion",
    movementPattern: "Hip Adduction",
    equipment: ["Multi-Hip Machine Station"],
    premium: true,
    favorite: false,
  },
  {
    id: "seated_hip_adductor_machine",
    name: "Seated Hip Adductor Machine",
    category: "Adductors/Hip Flexors",
    primaryMuscles: ["Adductors"],
    secondaryMuscles: [],
    romBias: "Shortened",
    mainTrainingApplication: "Hip Adduction, Hip Flexion, Knee Flexion",
    movementPattern: "Hip Adduction",
    equipment: ["Hip Adductor Machine Station"],
    premium: true,
    favorite: true,
  },
  {
    id: "standing_hip_adduction_with_band",
    name: "Standing Hip Adduction with Band",
    category: "Adductors/Hip Flexors",
    primaryMuscles: ["Adductors"],
    secondaryMuscles: [],
    romBias: "Shortened",
    mainTrainingApplication: "Hip Adduction, Hip Flexion, Knee Extension",
    movementPattern: "Hip Adduction",
    equipment: ["Band"],
    premium: false,
    favorite: false,
  },
  {
    id: "standing_hip_adduction_with_cable",
    name: "Standing Hip Adduction with Cable",
    category: "Adductors/Hip Flexors",
    primaryMuscles: ["Adductors"],
    secondaryMuscles: [],
    romBias: "Shortened",
    mainTrainingApplication: "Hip Adduction, Hip Flexion, Knee Extension",
    movementPattern: "Hip Adduction",
    equipment: ["Cable"],
    premium: true,
    favorite: false,
  },
  {
    id: "leg_press_feet_wide",
    name: "Leg Press Feet Wide",
    category: "Adductors/Hip Flexors",
    primaryMuscles: ["Adductor Magnus"],
    secondaryMuscles: ["Glutes", "Quads"],
    romBias: "Lengthened",
    mainTrainingApplication:
      "Hip Extension/Flexion, Hip Abduction/Adduction, Knee Flexion/Extension",
    movementPattern: "Leg Press",
    equipment: ["Leg Press Station"],
    premium: true,
    favorite: true,
  },
  {
    id: "copenhagen_plank_with_knees_bent",
    name: "Copenhagen Plank with Knees Bent",
    category: "Adductors/Hip Flexors",
    primaryMuscles: ["Adductors"],
    secondaryMuscles: ["Abs/Core"],
    romBias: "-",
    mainTrainingApplication: "Hip Adduction, Knee Flexion",
    movementPattern: "Hip Adduction",
    equipment: ["Adjustable Bench"],
    premium: true,
    favorite: false,
  },
  {
    id: "copenhagen_plank_with_knees_straight",
    name: "Copenhagen Plank with Knees Straight",
    category: "Adductors/Hip Flexors",
    primaryMuscles: ["Adductors"],
    secondaryMuscles: ["Abs/Core"],
    romBias: "-",
    mainTrainingApplication: "Hip Adduction, Knee Extension",
    movementPattern: "Hip Adduction",
    equipment: ["Adjustable Bench"],
    premium: true,
    favorite: false,
  },
  {
    id: "copenhagen_plank_with_hip_dip_adductor_bias",
    name: "Copenhagen Plank with Hip Dip Adductor Bias",
    category: "Adductors/Hip Flexors",
    primaryMuscles: ["Adductors"],
    secondaryMuscles: ["Abs/Core"],
    romBias: "Lengthened",
    mainTrainingApplication: "Hip Adduction/Abduction",
    movementPattern: "Hip Adduction",
    equipment: ["Adjustable Bench"],
    premium: true,
    favorite: false,
  },
  {
    id: "straddled_exercise_ball_adduction_squeeze",
    name: "Straddled Exercise Ball Adduction Squeeze",
    category: "Adductors/Hip Flexors",
    primaryMuscles: ["Adductors"],
    secondaryMuscles: [],
    romBias: "-",
    mainTrainingApplication: "Hip Adduction, Hip Flexion",
    movementPattern: "Hip Adduction",
    equipment: ["Exercise Ball"],
    premium: true,
    favorite: false,
  },
  {
    id: "hyperextension_45_degree_single_legged_adductor_focused",
    name: "45 Degree Hyper Extension Single-Legged Adductor Focused",
    category: "Adductors/Hip Flexors",
    primaryMuscles: ["Adductors"],
    secondaryMuscles: ["Abs/Core"],
    romBias: "Lengthened",
    mainTrainingApplication: "Hip Adduction/Abduction, Knee Extension",
    movementPattern: "Hip Hinge",
    equipment: ["45 Degree Hyper Extension Station"],
    premium: true,
    favorite: false,
  },
  {
    id: "lateral_lunge_with_db",
    name: "Lateral Lunge with DB",
    category: "Adductors/Hip Flexors",
    primaryMuscles: ["Adductors"],
    secondaryMuscles: ["Glutes", "Quads"],
    romBias: "Lengthened",
    mainTrainingApplication:
      "Hip Abduction, Flexion/Extension, Knee Flexion/Extension",
    movementPattern: "Lunge",
    equipment: ["Dumbbell"],
    premium: false,
    favorite: false,
  },
  {
    id: "cossack_squat_with_db",
    name: "Cossack Squat with DB",
    category: "Adductors/Hip Flexors",
    primaryMuscles: ["Adductors"],
    secondaryMuscles: ["Glutes", "Quads"],
    romBias: "Lengthened",
    mainTrainingApplication:
      "Hip Abduction, Flexion/Extension, Knee Flexion/Extension",
    movementPattern: "Squat",
    equipment: ["Dumbbell"],
    premium: true,
    favorite: false,
  },
  {
    id: "lateral_step_up_with_db",
    name: "Lateral Step-Up with DB",
    category: "Adductors/Hip Flexors",
    primaryMuscles: ["Adductors"],
    secondaryMuscles: ["Glutes", "Quads"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication:
      "Hip Abduction, Flexion/Extension, Knee Flexion/Extension",
    movementPattern: "Step-Up",
    equipment: ["Adjustable Bench", "Dumbbell"],
    premium: true,
    favorite: false,
  },
  {
    id: "lateral_step_up_with_cable_adductors",
    name: "Lateral Step-Up with Cable",
    category: "Adductors/Hip Flexors",
    primaryMuscles: ["Adductors"],
    secondaryMuscles: ["Glutes", "Quads"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication:
      "Hip Abduction, Flexion/Extension, Knee Flexion/Extension",
    movementPattern: "Step-Up",
    equipment: ["Adjustable Bench", "Cable"],
    premium: true,
    favorite: false,
  },
  {
    id: "multi_hip_machine_hip_flexion",
    name: "Multi-Hip Machine Hip Flexion",
    category: "Adductors/Hip Flexors",
    primaryMuscles: ["Iliacus/Psoas Major"],
    secondaryMuscles: [],
    romBias: "Shortened",
    mainTrainingApplication: "Hip Flexion/Extension, Knee Flexion",
    movementPattern: "Hip Flexion",
    equipment: ["Multi-Hip Machine Station"],
    premium: true,
    favorite: true,
  },
  {
    id: "single_leg_band_hip_flexion",
    name: "Single-Leg Band Hip Flexion",
    category: "Adductors/Hip Flexors",
    primaryMuscles: ["Iliacus/Psoas Major"],
    secondaryMuscles: [],
    romBias: "Shortened",
    mainTrainingApplication: "Hip Flexion/Extension, Knee Flexion/Extension",
    movementPattern: "Hip Flexion",
    equipment: ["Band"],
    premium: true,
    favorite: false,
  },
  {
    id: "single_leg_cable_hip_flexion",
    name: "Single-Leg Cable Hip Flexion",
    category: "Adductors/Hip Flexors",
    primaryMuscles: ["Iliacus/Psoas Major"],
    secondaryMuscles: [],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Hip Flexion/Extension, Knee Flexion/Extension",
    movementPattern: "Hip Flexion",
    equipment: ["Cable"],
    premium: true,
    favorite: true,
  },
  {
    id: "supine_straight_leg_raise",
    name: "Supine Straight Leg Raise",
    category: "Adductors/Hip Flexors",
    primaryMuscles: ["Iliacus/Psoas Major"],
    secondaryMuscles: [],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Hip Flexion, Knee Extension",
    movementPattern: "Hip Flexion",
    equipment: ["Bodyweight"],
    premium: true,
    favorite: false,
  },
  {
    id: "seated_straight_leg_raise",
    name: "Seated Straight Leg Raise",
    category: "Adductors/Hip Flexors",
    primaryMuscles: ["Iliacus/Psoas Major"],
    secondaryMuscles: [],
    romBias: "Shortened",
    mainTrainingApplication: "Hip Flexion, Knee Extension",
    movementPattern: "Hip Flexion",
    equipment: ["Bodyweight"],
    premium: true,
    favorite: false,
  },
  {
    id: "hip_flexor_lean_back",
    name: "Hip Flexor Lean Back",
    category: "Adductors/Hip Flexors",
    primaryMuscles: ["Iliacus/Psoas Major"],
    secondaryMuscles: ["Rectus Abdominus"],
    romBias: "Lengthened",
    mainTrainingApplication: "Hip Flexion/Extension, Knee Flexion",
    movementPattern: "Hip Flexion",
    equipment: ["Adjustable Bench", "Bodyweight"],
    premium: true,
    favorite: false,
  },
];
// ======================
// CALVES
// ======================

const calfExercises = [
  {
    id: "standing_calf_raise",
    name: "Standing Calf Raise",
    category: "Calves",
    primaryMuscles: ["Medial/Lateral Gastroc"],
    secondaryMuscles: ["Soleous"],
    romBias: "Shortened",
    mainTrainingApplication: "Ankle Plantarflexion, Knee Extension",
    movementPattern: "Plantarflexion",
    equipment: ["Bodyweight"],
    premium: true,
    favorite: false,
  },
  {
    id: "standing_single_leg_calf_raise",
    name: "Standing Single-Leg Calf Raise",
    category: "Calves",
    primaryMuscles: ["Medial/Lateral Gastroc"],
    secondaryMuscles: ["Soleous"],
    romBias: "Shortened",
    mainTrainingApplication: "Ankle Plantarflexion, Knee Extension",
    movementPattern: "Plantarflexion",
    equipment: ["Bodyweight"],
    premium: false,
    favorite: false,
  },
  {
    id: "standing_calf_raise_off_step",
    name: "Standing Calf Raise off Step",
    category: "Calves",
    primaryMuscles: ["Medial/Lateral Gastroc"],
    secondaryMuscles: ["Soleous"],
    romBias: "Shortened",
    mainTrainingApplication:
      "Ankle Plantarflexion/Dorsiflexion, Knee Extension",
    movementPattern: "Plantarflexion",
    equipment: ["Bodyweight", "Step"],
    premium: true,
    favorite: false,
  },
  {
    id: "standing_calf_raise_single_leg_off_step",
    name: "Standing Calf Raise Single-Leg off Step",
    category: "Calves",
    primaryMuscles: ["Medial/Lateral Gastroc"],
    secondaryMuscles: ["Soleous"],
    romBias: "Shortened",
    mainTrainingApplication:
      "Ankle Plantarflexion/Dorsiflexion, Knee Extension",
    movementPattern: "Plantarflexion",
    equipment: ["Bodyweight", "Step"],
    premium: true,
    favorite: false,
  },
  {
    id: "standing_machine_calf_raise",
    name: "Standing Machine Calf Raise",
    category: "Calves",
    primaryMuscles: ["Medial/Lateral Gastroc"],
    secondaryMuscles: ["Soleous", "Erectors"],
    romBias: "Shortened",
    mainTrainingApplication:
      "Ankle Plantarflexion/Dorsiflexion, Knee Extension",
    movementPattern: "Plantarflexion",
    equipment: ["Machine"],
    premium: true,
    favorite: false,
  },
  {
    id: "standing_smith_machine_calf_raise",
    name: "Standing Smith Machine Calf Raise",
    category: "Calves",
    primaryMuscles: ["Medial/Lateral Gastroc"],
    secondaryMuscles: ["Soleous", "Erectors"],
    romBias: "Shortened",
    mainTrainingApplication:
      "Ankle Plantarflexion/Dorsiflexion, Knee Extension",
    movementPattern: "Plantarflexion",
    equipment: ["Smith Machine"],
    premium: true,
    favorite: false,
  },
  {
    id: "donkey_calf_raise",
    name: "Donkey Calf Raise",
    category: "Calves",
    primaryMuscles: ["Medial/Lateral Gastroc"],
    secondaryMuscles: ["Soleous", "Erectors"],
    romBias: "Shortened",
    mainTrainingApplication:
      "Ankle Plantarflexion/Dorsiflexion, Knee Extension",
    movementPattern: "Plantarflexion",
    equipment: ["Bodyweight/Donkey Calf Raise Machine Station"],
    premium: true,
    favorite: true,
  },
  {
    id: "seated_machine_calf_press",
    name: "Seated Machine Calf Press",
    category: "Calves",
    primaryMuscles: ["Soleous"],
    secondaryMuscles: ["Medial/Lateral Gastroc"],
    romBias: "Shortened",
    mainTrainingApplication:
      "Ankle Plantarflexion/Dorsiflexion, Knee Extension",
    movementPattern: "Plantarflexion",
    equipment: ["Machine"],
    premium: true,
    favorite: true,
  },
  {
    id: "seated_machine_single_leg_calf_press",
    name: "Seated Machine Single-Leg Calf Press",
    category: "Calves",
    primaryMuscles: ["Soleous"],
    secondaryMuscles: ["Medial/Lateral Gastroc"],
    romBias: "Shortened",
    mainTrainingApplication:
      "Ankle Plantarflexion/Dorsiflexion, Knee Extension",
    movementPattern: "Plantarflexion",
    equipment: ["Machine"],
    premium: true,
    favorite: true,
  },
  {
    id: "calf_press_on_leg_press",
    name: "Calf Press on Leg Press",
    category: "Calves",
    primaryMuscles: ["Medial/Lateral Gastroc"],
    secondaryMuscles: ["Soleous"],
    romBias: "Shortened",
    mainTrainingApplication:
      "Ankle Plantarflexion/Dorsiflexion, Knee Extension",
    movementPattern: "Plantarflexion",
    equipment: ["Leg Press Station"],
    premium: true,
    favorite: true,
  },
  {
    id: "single_leg_calf_press_on_leg_press",
    name: "Single-Leg Calf Press on Leg Press",
    category: "Calves",
    primaryMuscles: ["Medial/Lateral Gastroc"],
    secondaryMuscles: ["Soleous"],
    romBias: "Shortened",
    mainTrainingApplication:
      "Ankle Plantarflexion/Dorsiflexion, Knee Extension",
    movementPattern: "Plantarflexion",
    equipment: ["Leg Press Station"],
    premium: true,
    favorite: true,
  },
  {
    id: "squat_iso_with_calf_raise",
    name: "Squat ISO with Calf Raise",
    category: "Calves",
    primaryMuscles: ["Soleous"],
    secondaryMuscles: ["Medial/Lateral Gastroc"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Ankle Plantarflexion/Dorsiflexion, Knee Flexion",
    movementPattern: "Plantarflexion",
    equipment: ["Bodyweight"],
    premium: false,
    favorite: true,
  },
  {
    id: "seated_calf_raise_with_db",
    name: "Seated Calf Raise with DB",
    category: "Calves",
    primaryMuscles: ["Soleous"],
    secondaryMuscles: ["Medial/Lateral Gastroc"],
    romBias: "Shortened",
    mainTrainingApplication: "Ankle Plantarflexion/Dorsiflexion, Knee Flexion",
    movementPattern: "Plantarflexion",
    equipment: ["Adjustable Bench", "Dumbbell"],
    premium: true,
    favorite: false,
  },
  {
    id: "seated_calf_raise_machine",
    name: "Seated Calf Raise Machine",
    category: "Calves",
    primaryMuscles: ["Soleous"],
    secondaryMuscles: ["Medial/Lateral Gastroc"],
    romBias: "Shortened",
    mainTrainingApplication: "Ankle Plantarflexion/Dorsiflexion, Knee Flexion",
    movementPattern: "Plantarflexion",
    equipment: ["Seated Calf Raise Machine Station"],
    premium: true,
    favorite: false,
  },
];
// ======================
// REHAB / MOBILITY / EXTRA CREDIT
// ======================

const rehabMobilityExercises = [
  {
    id: "shoulder_external_rotation_0_banded",
    name: "Shoulder External Rotation at 0 Degrees Banded",
    category: "Rehab/Mobility",
    primaryMuscles: ["Infraspinatus", "Teres Minor"],
    secondaryMuscles: ["Posterior Delt"],
    romBias: "Shortened",
    mainTrainingApplication: "Gleonhumeral External Rotation/Internal Rotation",
    movementPattern: "Shoulder External Rotation",
    equipment: ["Band"],
    premium: false,
    favorite: false,
  },
  {
    id: "shoulder_external_rotation_0_cable",
    name: "Shoulder External Rotation at 0 Degrees Cable",
    category: "Rehab/Mobility",
    primaryMuscles: ["Infraspinatus", "Teres Minor"],
    secondaryMuscles: ["Posterior Delt"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Gleonhumeral External Rotation/Internal Rotation",
    movementPattern: "Shoulder External Rotation",
    equipment: ["Cable"],
    premium: true,
    favorite: false,
  },
  {
    id: "shoulder_external_rotation_0_db_sidelying",
    name: "Shoulder External Rotation at 0 Degrees DB Sidelying",
    category: "Rehab/Mobility",
    primaryMuscles: ["Infraspinatus", "Teres Minor"],
    secondaryMuscles: ["Posterior Delt"],
    romBias: "Shortened",
    mainTrainingApplication: "Gleonhumeral External Rotation/Internal Rotation",
    movementPattern: "Shoulder External Rotation",
    equipment: ["Adjustable Bench", "Dumbbell"],
    premium: true,
    favorite: false,
  },
  {
    id: "shoulder_external_rotation_90_banded",
    name: "Shoulder External Rotation at 90 Degrees Banded",
    category: "Rehab/Mobility",
    primaryMuscles: ["Teres Minor", "Infraspinatus"],
    secondaryMuscles: ["Posterior/Medial Delt"],
    romBias: "Shortened",
    mainTrainingApplication:
      "Gleonhumeral External Rotation/Internal Rotation, Glenohumeral Abduction",
    movementPattern: "Shoulder External Rotation",
    equipment: ["Band"],
    premium: true,
    favorite: true,
  },
  {
    id: "shoulder_external_rotation_90_cable",
    name: "Shoulder External Rotation at 90 Degrees Cable",
    category: "Rehab/Mobility",
    primaryMuscles: ["Teres Minor", "Infraspinatus"],
    secondaryMuscles: ["Posterior/Medial Delt"],
    romBias: "Shortened",
    mainTrainingApplication:
      "Gleonhumeral External Rotation/Internal Rotation, Glenohumeral Abduction",
    movementPattern: "Shoulder External Rotation",
    equipment: ["Cable"],
    premium: true,
    favorite: false,
  },
  {
    id: "shoulder_external_rotation_90_db_prone",
    name: "Shoulder External Rotation at 90 Degrees DB Prone",
    category: "Rehab/Mobility",
    primaryMuscles: ["Teres Minor", "Infraspinatus"],
    secondaryMuscles: ["Posterior/Medial Delt"],
    romBias: "Shortened",
    mainTrainingApplication:
      "Gleonhumeral External Rotation/Internal Rotation, Glenohumeral Abduction",
    movementPattern: "Shoulder External Rotation",
    equipment: ["Adjustable Bench", "Dumbbell"],
    premium: true,
    favorite: false,
  },
  {
    id: "shoulder_internal_rotation_0_banded",
    name: "Shoulder Internal Rotation at 0 Degrees Banded",
    category: "Rehab/Mobility",
    primaryMuscles: ["Subscapularis", "Supraspinatus"],
    secondaryMuscles: ["Anterior Delt/Pec"],
    romBias: "Shortened",
    mainTrainingApplication: "Gleonhumeral External Rotation/Internal Rotation",
    movementPattern: "Shoulder Internal Rotation",
    equipment: ["Band"],
    premium: false,
    favorite: false,
  },
  {
    id: "shoulder_internal_rotation_0_cable",
    name: "Shoulder Internal Rotation at 0 Degrees Cable",
    category: "Rehab/Mobility",
    primaryMuscles: ["Subscapularis", "Supraspinatus"],
    secondaryMuscles: ["Anterior Delt/Pec"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication: "Gleonhumeral External Rotation/Internal Rotation",
    movementPattern: "Shoulder Internal Rotation",
    equipment: ["Cable"],
    premium: true,
    favorite: false,
  },
  {
    id: "shoulder_internal_rotation_90_banded",
    name: "Shoulder Internal Rotation at 90 Degrees Banded",
    category: "Rehab/Mobility",
    primaryMuscles: ["Subscapularis", "Supraspinatus"],
    secondaryMuscles: ["Anterior Delt/Medial Delt/Pec"],
    romBias: "Shortened",
    mainTrainingApplication:
      "Gleonhumeral External Rotation/Internal Rotation, Glenohumeral Abduction",
    movementPattern: "Shoulder Internal Rotation",
    equipment: ["Band"],
    premium: true,
    favorite: false,
  },
  {
    id: "shoulder_internal_rotation_90_cable",
    name: "Shoulder Internal Rotation at 90 Degrees Cable",
    category: "Rehab/Mobility",
    primaryMuscles: ["Subscapularis", "Supraspinatus"],
    secondaryMuscles: ["Anterior Delt/Medial Delt/Pec"],
    romBias: "Mid-Lengthened",
    mainTrainingApplication:
      "Gleonhumeral External Rotation/Internal Rotation, Glenohumeral Abduction",
    movementPattern: "Shoulder Internal Rotation",
    equipment: ["Cable"],
    premium: true,
    favorite: false,
  },
  {
    id: "shoulder_internal_rotation_90_db_supine",
    name: "Shoulder Internal Rotation at 90 Degrees DB Supine",
    category: "Rehab/Mobility",
    primaryMuscles: ["Subscapularis", "Supraspinatus"],
    secondaryMuscles: ["Anterior Delt/Medial Delt/Pec"],
    romBias: "Lengthened",
    mainTrainingApplication:
      "Gleonhumeral External Rotation/Internal Rotation, Glenohumeral Abduction",
    movementPattern: "Shoulder Internal Rotation",
    equipment: ["Adjustable Bench", "Dumbbell"],
    premium: true,
    favorite: false,
  },
  {
    id: "wall_clock",
    name: "Wall Clock",
    category: "Rehab/Mobility",
    primaryMuscles: [
      "Medial Delt",
      "Posterior Delt",
      "Supraspinatus",
      "Infraspinatus",
    ],
    secondaryMuscles: [],
    romBias: "-",
    mainTrainingApplication:
      "Glenohumeral Abduction, Glenohumeral Flexion/Extension",
    movementPattern: "Shoulder Control",
    equipment: ["Band", "Wall"],
    premium: false,
    favorite: false,
  },
  {
    id: "wall_spider",
    name: "Wall Spider",
    category: "Rehab/Mobility",
    primaryMuscles: [
      "Medial Delt",
      "Posterior Delt",
      "Supraspinatus",
      "Infraspinatus",
    ],
    secondaryMuscles: [],
    romBias: "-",
    mainTrainingApplication:
      "Glenohumeral Abduction, Glenohumeral Flexion/Extension",
    movementPattern: "Shoulder Control",
    equipment: ["Band", "Wall"],
    premium: true,
    favorite: true,
  },
  {
    id: "serratus_wall_slide",
    name: "Serratus Wall Slide",
    category: "Rehab/Mobility",
    primaryMuscles: ["Serratus Anterior/Posterior"],
    secondaryMuscles: ["Anterior Delt", "Rhomboids"],
    romBias: "Shortened",
    mainTrainingApplication:
      "Glenohumeral Abduction, Glenohumeral Flexion/Extension, Scapular Protraction/Retraction/Upward Rotation",
    movementPattern: "Scapular Control",
    equipment: ["Band", "Wall"],
    premium: true,
    favorite: true,
  },
  {
    id: "shoulder_dislocates_with_band",
    name: "Shoulder Dislocates with Band",
    category: "Rehab/Mobility",
    primaryMuscles: [
      "Anterior/Medial/Posterior Delt",
      "Pec",
      "Rhomboids",
      "Lats",
    ],
    secondaryMuscles: [],
    romBias: "-",
    mainTrainingApplication:
      "Glenohumeral Internal/External Rotation, Flexion/Extension, Abduction/Adduction",
    movementPattern: "Shoulder Mobility",
    equipment: ["Band"],
    premium: true,
    favorite: false,
  },
  {
    id: "shoulder_dislocates_with_bar",
    name: "Shoulder Dislocates with Bar",
    category: "Rehab/Mobility",
    primaryMuscles: [
      "Anterior/Medial/Posterior Delt",
      "Pec",
      "Rhomboids",
      "Lats",
    ],
    secondaryMuscles: [],
    romBias: "-",
    mainTrainingApplication:
      "Glenohumeral Internal/External Rotation, Flexion/Extension, Abduction/Adduction",
    movementPattern: "Shoulder Mobility",
    equipment: ["Bar"],
    premium: true,
    favorite: true,
  },
  {
    id: "shoulder_cars",
    name: "Shoulder Controlled Articular Rotations (CARs)",
    category: "Rehab/Mobility",
    primaryMuscles: [
      "Anterior/Medial/Posterior Delt",
      "Pec",
      "Rhomboids",
      "Lats",
    ],
    secondaryMuscles: [],
    romBias: "-",
    mainTrainingApplication:
      "Glenohumeral Internal/External Rotation, Flexion/Extension, Abduction/Adduction",
    movementPattern: "Shoulder Mobility",
    equipment: ["Wall"],
    premium: true,
    favorite: true,
  },
  {
    id: "deadbug_alternating_march",
    name: "Deadbug / Alternating March",
    category: "Rehab/Mobility",
    primaryMuscles: ["Abs", "Hip Flexors"],
    secondaryMuscles: [],
    romBias: "-",
    mainTrainingApplication: "Resisted Spinal Extension",
    movementPattern: "Core Stability",
    equipment: ["Bodyweight"],
    premium: false,
    favorite: false,
  },
  {
    id: "hollow_body_hold",
    name: "Hollow-Body Hold",
    category: "Rehab/Mobility",
    primaryMuscles: ["Abs", "Hip Flexors"],
    secondaryMuscles: [],
    romBias: "-",
    mainTrainingApplication: "Resisted Spinal Extension",
    movementPattern: "Core Stability",
    equipment: ["Bodyweight"],
    premium: true,
    favorite: false,
  },
  {
    id: "bird_dog",
    name: "Bird Dog",
    category: "Rehab/Mobility",
    primaryMuscles: ["Abs"],
    secondaryMuscles: [],
    romBias: "-",
    mainTrainingApplication: "Resisted Spinal Extension",
    movementPattern: "Core Stability",
    equipment: ["Bodyweight"],
    premium: false,
    favorite: false,
  },
  {
    id: "ab_wheel_roll_out",
    name: "Ab Wheel Roll-Out",
    category: "Rehab/Mobility",
    primaryMuscles: ["Abs"],
    secondaryMuscles: [],
    romBias: "Lengthened",
    mainTrainingApplication: "Resisted Spinal Extension",
    movementPattern: "Core Stability",
    equipment: ["Bodyweight"],
    premium: true,
    favorite: false,
  },
  {
    id: "suitcase_carry_for_abs",
    name: "Suitcase Carry for Abs",
    category: "Rehab/Mobility",
    primaryMuscles: ["Abs"],
    secondaryMuscles: [],
    romBias: "-",
    mainTrainingApplication: "Abdominal Bracing",
    movementPattern: "Carry",
    equipment: ["Bodyweight"],
    premium: true,
    favorite: false,
  },
  {
    id: "waiter_carry_for_abs",
    name: "Waiter Carry for Abs",
    category: "Rehab/Mobility",
    primaryMuscles: ["Abs"],
    secondaryMuscles: [],
    romBias: "-",
    mainTrainingApplication: "Abdominal Bracing",
    movementPattern: "Carry",
    equipment: ["Bodyweight"],
    premium: true,
    favorite: false,
  },
  {
    id: "prone_press_up",
    name: "Prone Press-Up",
    category: "Rehab/Mobility",
    primaryMuscles: ["Spinal Erectors"],
    secondaryMuscles: [],
    romBias: "Shortened",
    mainTrainingApplication: "Spinal Extension",
    movementPattern: "Spinal Extension",
    equipment: ["Bodyweight"],
    premium: false,
    favorite: false,
  },
  {
    id: "superman_hold",
    name: "Superman Hold",
    category: "Rehab/Mobility",
    primaryMuscles: ["Spinal Erectors"],
    secondaryMuscles: [],
    romBias: "Shortened",
    mainTrainingApplication: "Spinal Extension",
    movementPattern: "Spinal Extension",
    equipment: ["Bodyweight"],
    premium: true,
    favorite: false,
  },
  {
    id: "superman_raises",
    name: "Superman Raises",
    category: "Rehab/Mobility",
    primaryMuscles: ["Spinal Erectors"],
    secondaryMuscles: [],
    romBias: "Shortened",
    mainTrainingApplication: "Spinal Extension",
    movementPattern: "Spinal Extension",
    equipment: ["Bodyweight"],
    premium: true,
    favorite: false,
  },
  {
    id: "cat_camel",
    name: "Cat/Camel",
    category: "Rehab/Mobility",
    primaryMuscles: ["Spinal Erectors", "Abs"],
    secondaryMuscles: [],
    romBias: "-",
    mainTrainingApplication: "Spinal Flexion/Extension",
    movementPattern: "Spinal Mobility",
    equipment: [],
    premium: true,
    favorite: false,
  },
  {
    id: "tib_raises",
    name: "Tib Raises",
    category: "Rehab/Mobility",
    primaryMuscles: ["Tibialis Anterior"],
    secondaryMuscles: [],
    romBias: "Shortened",
    mainTrainingApplication: "Ankle Dorsiflexion/Plantarflexion",
    movementPattern: "Ankle Dorsiflexion",
    equipment: ["Bodyweight", "Wall"],
    premium: true,
    favorite: false,
  },
  {
    id: "seated_tibial_internal_external_rotation_drill",
    name: "Seated Tibial Internal/External Rotaton Drill",
    category: "Rehab/Mobility",
    primaryMuscles: ["Tibialis Anterior", "Popliteus", "Hamstrings"],
    secondaryMuscles: [],
    romBias: "-",
    mainTrainingApplication:
      "Tibial Internal/Extenal Rotation, Knee Flexion/Extension",
    movementPattern: "Tibial Rotation",
    equipment: [],
    premium: true,
    favorite: true,
  },
  {
    id: "toe_yoga",
    name: "Toe Yoga",
    category: "Rehab/Mobility",
    primaryMuscles: ["Foot Intrinsics"],
    secondaryMuscles: [],
    romBias: "Shortened",
    mainTrainingApplication:
      "Great Toe Extension, 2-5 Toe Extension, Toe Abdution, Medial Arch Flexion",
    movementPattern: "Foot Control",
    equipment: [],
    premium: true,
    favorite: false,
  },
  {
    id: "hip_cars",
    name: "Hip Controlled Articular Rotations (CARs)",
    category: "Rehab/Mobility",
    primaryMuscles: [
      "Iliopsoas",
      "Glute Max/Med/Min",
      "Internal/External Rotators",
    ],
    secondaryMuscles: [],
    romBias: "-",
    mainTrainingApplication:
      "Hip Internal/External Rotation, Flexion/Extension, Abudction/Adduction",
    movementPattern: "Hip Mobility",
    equipment: ["Wall/Rack"],
    premium: true,
    favorite: true,
  },
  {
    id: "hip_airplanes",
    name: "Hip Airplanes",
    category: "Rehab/Mobility",
    primaryMuscles: ["Glute Max/Med/Min", "Internal/External Rotators"],
    secondaryMuscles: [],
    romBias: "-",
    mainTrainingApplication: "Hip Internal/External Rotation, Hip Flexion",
    movementPattern: "Hip Stability",
    equipment: ["Bodyweight"],
    premium: false,
    favorite: false,
  },
  {
    id: "worlds_greatest_stretch",
    name: "World's Greatest Stretch",
    category: "Rehab/Mobility",
    primaryMuscles: ["Glutes", "Iliopsoas", "Spinal Rotations"],
    secondaryMuscles: [],
    romBias: "-",
    mainTrainingApplication:
      "Hip Flexion/Extension, Spinal Flexion/Extension, Spinal Rotation",
    movementPattern: "Mobility",
    equipment: ["Bodyweight"],
    premium: true,
    favorite: false,
  },
  {
    id: "adductor_rockers_long_lever",
    name: "Adductor Rockers Long lever",
    category: "Rehab/Mobility",
    primaryMuscles: ["Adductors", "Hamstrings"],
    secondaryMuscles: [],
    romBias: "Lengthened",
    mainTrainingApplication: "Hip Abduction, Hip Flexion, Knee Extension",
    movementPattern: "Mobility",
    equipment: ["Bodyweight"],
    premium: true,
    favorite: false,
  },
  {
    id: "adductor_rockers_short_lever",
    name: "Adductor Rockers Short Lever",
    category: "Rehab/Mobility",
    primaryMuscles: ["Adductors", "Hamstrings"],
    secondaryMuscles: [],
    romBias: "Lengthened",
    mainTrainingApplication: "Hip Abduction, Hip Flexion, Knee Flexion",
    movementPattern: "Mobility",
    equipment: ["Bodyweight"],
    premium: true,
    favorite: false,
  },
  {
    id: "kneeling_adductor_lunge",
    name: "Kneeling Adductor Lunge",
    category: "Rehab/Mobility",
    primaryMuscles: ["Adductors", "Hamstrings"],
    secondaryMuscles: [],
    romBias: "Lengthened",
    mainTrainingApplication: "Hip Abduction, Hip Flexion, Knee Flexion",
    movementPattern: "Mobility",
    equipment: ["Bodyweight"],
    premium: true,
    favorite: true,
  },
  {
    id: "hip_flexor_stretch_with_back_leg_on_box",
    name: "Hip Flexor Stretch with Back Leg on Box",
    category: "Rehab/Mobility",
    primaryMuscles: ["Iliopsoas", "Rectus Femoris"],
    secondaryMuscles: [],
    romBias: "Lengthened",
    mainTrainingApplication: "Hip Extension, Knee Flexion",
    movementPattern: "Mobility",
    equipment: ["Adjustable Bench"],
    premium: true,
    favorite: true,
  },
  {
    id: "elephant_walks",
    name: "Elephant Walks",
    category: "Rehab/Mobility",
    primaryMuscles: ["Hamstrings"],
    secondaryMuscles: [],
    romBias: "Lengthened",
    mainTrainingApplication: "Hip Flexion, Knee Flexion/Extension",
    movementPattern: "Mobility",
    equipment: [],
    premium: true,
    favorite: true,
  },
  {
    id: "standing_pigeon_stretch",
    name: "Standing Pigeon Stretch",
    category: "Rehab/Mobility",
    primaryMuscles: ["Hip Internal/External Rotators"],
    secondaryMuscles: [],
    romBias: "Lengthened",
    mainTrainingApplication: "Hip External Rotation, Hip Flexion",
    movementPattern: "Mobility",
    equipment: ["Adjustable Bench"],
    premium: true,
    favorite: true,
  },
  {
    id: "hip_90_90_stretch_seated",
    name: "90-90 Hip Stretch Seated",
    category: "Rehab/Mobility",
    primaryMuscles: ["Hip Internal/External Rotators"],
    secondaryMuscles: [],
    romBias: "-",
    mainTrainingApplication:
      "Hip Internal/External Rotation, Hip Flexion/Extension",
    movementPattern: "Mobility",
    equipment: ["Floor"],
    premium: true,
    favorite: true,
  },
  {
    id: "supine_adduction_squeeze",
    name: "Supine Adduction Squeeze",
    category: "Rehab/Mobility",
    primaryMuscles: ["Adductors"],
    secondaryMuscles: [],
    romBias: "-",
    mainTrainingApplication: "Hip Adduction, Hip Flexion, Knee Flexion",
    movementPattern: "Adduction",
    equipment: ["Floor"],
    premium: true,
    favorite: false,
  },
  {
    id: "seated_adduction_squeeze",
    name: "Seated Adduction Squeeze",
    category: "Rehab/Mobility",
    primaryMuscles: ["Adductors"],
    secondaryMuscles: [],
    romBias: "-",
    mainTrainingApplication: "Hip Adduction, Hip Flexion, Knee Flexion",
    movementPattern: "Adduction",
    equipment: ["Adjustable Bench"],
    premium: true,
    favorite: false,
  },
  {
    id: "calf_raise_with_ball_squeeze",
    name: "Calf Raise with ball Squeeze",
    category: "Rehab/Mobility",
    primaryMuscles: ["Gastroc/Soleous", "Posterior Tibialis"],
    secondaryMuscles: [],
    romBias: "Shortened",
    mainTrainingApplication:
      "Ankle Dorsiflexion/Plantarflexion, Ankle Inversion",
    movementPattern: "Plantarflexion",
    equipment: ["Bodyweight", "Ball"],
    premium: false,
    favorite: false,
  },
];
// ======================
// MASTER EXERCISE DATABASE
// ======================

const exerciseDatabase = [
  // Core
  ...absExercises,
  ...erectorExercises,
  ...rotationExercises,

  // Upper Body - Shoulders
  ...anteriorDeltExercises,
  ...medialDeltExercises,
  ...posteriorDeltExercises,

  // Upper Body - Arms
  ...bicepsExercises,
  ...tricepsExercises,

  // Upper Body - Chest/Back
  ...chestExercises,
  ...latExercises,
  ...trapExercises,

  // Lower Body
  ...quadExercises,
  ...hamstringExercises,
  ...gluteExercises,
  ...adductorHipFlexorExercises,
  ...calfExercises,

  // Rehab / Mobility
  ...rehabMobilityExercises,
];

export default exerciseDatabase;
